// import React, {useState} from 'react';
// import {
//     Award,
//     CheckCircle,
//     ChevronLeft,
//     ChevronRight,
//     Clock,
//     ExternalLink,
//     Mail,
//     MapPin,
//     MessageCircle,
//     Phone,
//     Star,
//     Users
// } from 'lucide-react';
// import {Header} from "../components/Header";
//
// export const YellowPageEntityPublicProfile = () => {
//     const [currentImageIndex, setCurrentImageIndex] = useState(0);
//     const [isFavorited, setIsFavorited] = useState(false);
//
//     // Sample data based on the registration form structure
//     const entityData = {
//         type: 'Business Entity',
//         subType: 'Both', // Products & Services
//         name: 'TechFix Solutions',
//         ownerName: 'Rajesh Kumar',
//         category: 'Electronics & Electrical',
//         area: 'Bhayandar West',
//         pinCode: '401101',
//         address: 'Shop No. 15, Maxus Mall, Near Railway Station, Bhayandar West',
//         mobile: '+91 98765 43210',
//         whatsapp: '+91 98765 43210',
//         email: 'info@techfixsolutions.com',
//         experience: '5-10 years',
//         description: 'We sell latest mobile phones, laptops, and electronic gadgets. We also provide professional repair services for all brands of smartphones, laptops, and electronic devices with genuine spare parts and warranty.',
//         images: [
//             '/assets/tech-filler-1.png',
//             '/assets/tech-filler-2.png',
//             '/assets/tech-filler-3.png'
//         ],
//         rating: 4.6,
//         reviewCount: 127,
//         isVerified: true,
//         operatingHours: {
//             monday: '9:00 AM - 8:00 PM',
//             tuesday: '9:00 AM - 8:00 PM',
//             wednesday: '9:00 AM - 8:00 PM',
//             thursday: '9:00 AM - 8:00 PM',
//             friday: '9:00 AM - 8:00 PM',
//             saturday: '9:00 AM - 8:00 PM',
//             sunday: '10:00 AM - 6:00 PM'
//         },
//         services: [
//             'Mobile Phone Sales',
//             'Laptop Sales',
//             'Screen Repair',
//             'Battery Replacement',
//             'Software Installation',
//             'Data Recovery'
//         ],
//         specialOffers: [
//             'Free screen guard with every phone purchase',
//             '10% discount on repair services for students',
//             'Extended warranty available'
//         ]
//     };
//
//     const nextImage = () => {
//         setCurrentImageIndex((prev) =>
//             prev === entityData.images.length - 1 ? 0 : prev + 1
//         );
//     };
//
//     const prevImage = () => {
//         setCurrentImageIndex((prev) =>
//             prev === 0 ? entityData.images.length - 1 : prev - 1
//         );
//     };
//
//     const getCurrentDay = () => {
//         const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
//         return days[new Date().getDay()];
//     };
//
//     const isOpenNow = () => {
//         const currentHours = entityData.operatingHours[getCurrentDay()];
//         return currentHours && currentHours !== 'Closed';
//     };
//
//     return (
//         <div
//             className={`min-h-[100dvh] h-[100dvh] max-h-[100dvh]
//                 min-w-full w-full max-w-full
//                 bg-white flex flex-col justify-end`}
//         >
//             {/* Header */}
//             <Header/>
//
//             {/* Main Content */}
//             <div
//                 className="bg-orange-50 font-custom-sans text-gray-800 min-h-screen
//                     flex flex-col justify-between thin-scrollbar overflow-y-scroll min-w-full w-full max-w-full
//
//                     portrait:pt-[4.75rem] portrait:sm:pt-[6.25rem] portrait:jk:pt-[5.75rem]
//
//                     portrait:min-h-[100dvh] portrait:h-[100dvh] portrait:max-h-[100dvh]
//
//                     landscape:pt-[3.5rem] landscape:jk:pt-[4.5rem]
//
//                     landscape:min-h-[100dvh] landscape:h-[100dvh] landscape:max-h-[100dvh]
//
//                     portrait:pb-[0.75rem] portrait:pl-[0.75rem] portrait:pr-[0.75rem]
//                     landscape:pb-[0.5rem] landscape:pl-[0.5rem] landscape:pr-[0.5rem]
//
//                     portrait:gap-[0.75rem] landscape:gap-[0.5rem]"
//             >
//                 <div className="max-w-6xl mx-auto px-4 py-6">
//                     <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//                         {/* Main Content */}
//                         <div className="lg:col-span-2 space-y-6">
//                             {/* Business Header */}
//                             <div className="bg-white rounded-xl shadow-sm p-6">
//                                 <div className="flex items-start justify-between mb-4">
//                                     <div className="flex-1">
//                                         <div className="flex items-center gap-2 mb-2">
//                                             <h1 className="text-3xl font-custom-bold text-gray-900">{entityData.name}</h1>
//                                             {entityData.isVerified && (
//                                                 <CheckCircle className="w-6 h-6 text-blue-600"/>
//                                             )}
//                                         </div>
//                                         <p className="text-gray-600 mb-2">Owned by {entityData.ownerName}</p>
//                                         <div className="flex items-center gap-4 text-sm text-gray-500">
//                                 <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full">
//                                   {entityData.category}
//                                 </span>
//                                             <div className="flex items-center gap-1">
//                                                 <Award className="w-4 h-4"/>
//                                                 <span>{entityData.experience} experience</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//
//                                 {/* Rating and Reviews */}
//                                 <div className="flex items-center gap-4 mb-4">
//                                     <div className="flex items-center gap-2">
//                                         <div className="flex items-center">
//                                             {[1, 2, 3, 4, 5].map((star) => (
//                                                 <Star
//                                                     key={star}
//                                                     className={`w-5 h-5 ${
//                                                         star <= Math.floor(entityData.rating)
//                                                             ? 'text-yellow-400 fill-current'
//                                                             : 'text-gray-300'
//                                                     }`}
//                                                 />
//                                             ))}
//                                         </div>
//                                         <span className="font-custom-semi-bold">{entityData.rating}</span>
//                                         <span className="text-gray-600">({entityData.reviewCount} reviews)</span>
//                                     </div>
//                                     <div className={`flex items-center gap-1 text-sm font-custom-medium ${
//                                         isOpenNow() ? 'text-green-600' : 'text-red-600'
//                                     }`}>
//                                         <Clock className="w-4 h-4"/>
//                                         {isOpenNow() ? 'Open Now' : 'Closed'}
//                                     </div>
//                                 </div>
//
//                                 {/* Description */}
//                                 <div className="prose max-w-none">
//                                     <p className="text-gray-700 leading-relaxed">{entityData.description}</p>
//                                 </div>
//                             </div>
//
//                             {/* Image Gallery */}
//                             <div className="bg-white rounded-xl shadow-sm overflow-hidden">
//                                 <div className="relative">
//                                     <img
//                                         src={entityData.images[currentImageIndex]}
//                                         alt={`${entityData.name} - Image ${currentImageIndex + 1}`}
//                                         className="w-full h-96 object-cover"
//                                     />
//                                     {entityData.images.length > 1 && (
//                                         <>
//                                             <button
//                                                 onClick={prevImage}
//                                                 className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors"
//                                             >
//                                                 <ChevronLeft className="w-5 h-5"/>
//                                             </button>
//                                             <button
//                                                 onClick={nextImage}
//                                                 className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors"
//                                             >
//                                                 <ChevronRight className="w-5 h-5"/>
//                                             </button>
//                                             <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
//                                                 {entityData.images.map((_, index) => (
//                                                     <button
//                                                         key={index}
//                                                         onClick={() => setCurrentImageIndex(index)}
//                                                         className={`w-2 h-2 rounded-full transition-colors ${
//                                                             index === currentImageIndex ? 'bg-white' : 'bg-white/50'
//                                                         }`}
//                                                     />
//                                                 ))}
//                                             </div>
//                                         </>
//                                     )}
//                                 </div>
//                             </div>
//
//                             {/* Services/Products */}
//                             <div className="bg-white rounded-xl shadow-sm p-6">
//                                 <h2 className="text-xl font-custom-bold text-gray-900 mb-4">Services & Products</h2>
//                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                                     {entityData.services.map((service, index) => (
//                                         <div key={index} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
//                                             <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0"/>
//                                             <span className="text-gray-700">{service}</span>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//
//                             {/* Special Offers */}
//                             <div className="bg-white rounded-xl shadow-sm p-6">
//                                 <h2 className="text-xl font-custom-bold text-gray-900 mb-4">Special Offers</h2>
//                                 <div className="space-y-3">
//                                     {entityData.specialOffers.map((offer, index) => (
//                                         <div key={index}
//                                              className="flex items-start gap-3 p-4 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg border border-green-200">
//                                             <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
//                                             <span className="text-gray-700">{offer}</span>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>
//
//                         {/* Sidebar */}
//                         <div className="space-y-6">
//                             {/* Contact Information */}
//                             <div className="bg-white rounded-xl shadow-sm p-6">
//                                 <h3 className="text-lg font-custom-bold text-gray-900 mb-4">Contact Information</h3>
//                                 <div className="space-y-4">
//                                     <a
//                                         href={`tel:${entityData.mobile}`}
//                                         className="flex items-center gap-3 p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors group"
//                                     >
//                                         <Phone className="w-5 h-5 text-blue-600"/>
//                                         <div>
//                                             <p className="font-custom-medium text-gray-900 group-hover:text-blue-700">Call
//                                                 Now</p>
//                                             <p className="text-sm text-gray-600">{entityData.mobile}</p>
//                                         </div>
//                                     </a>
//
//                                     <a
//                                         href={`https://wa.me/${entityData.whatsapp.replace(/[^0-9]/g, '')}`}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         className="flex items-center gap-3 p-3 bg-green-50 hover:bg-green-100 rounded-lg transition-colors group"
//                                     >
//                                         <MessageCircle className="w-5 h-5 text-green-600"/>
//                                         <div>
//                                             <p className="font-custom-medium text-gray-900 group-hover:text-green-700">WhatsApp</p>
//                                             <p className="text-sm text-gray-600">{entityData.whatsapp}</p>
//                                         </div>
//                                     </a>
//
//                                     {entityData.email && (
//                                         <a
//                                             href={`mailto:${entityData.email}`}
//                                             className="flex items-center gap-3 p-3 bg-purple-50 hover:bg-purple-100 rounded-lg transition-colors group"
//                                         >
//                                             <Mail className="w-5 h-5 text-purple-600"/>
//                                             <div>
//                                                 <p className="font-custom-medium text-gray-900 group-hover:text-purple-700">Email</p>
//                                                 <p className="text-sm text-gray-600">{entityData.email}</p>
//                                             </div>
//                                         </a>
//                                     )}
//                                 </div>
//                             </div>
//
//                             {/* Location */}
//                             <div className="bg-white rounded-xl shadow-sm p-6">
//                                 <h3 className="text-lg font-custom-bold text-gray-900 mb-4">Location</h3>
//                                 <div className="space-y-3">
//                                     <div className="flex items-start gap-3">
//                                         <MapPin className="w-5 h-5 text-red-600 mt-1 flex-shrink-0"/>
//                                         <div>
//                                             <p className="text-gray-700">{entityData.address}</p>
//                                             <p className="text-sm text-gray-500">{entityData.area}, {entityData.pinCode}</p>
//                                         </div>
//                                     </div>
//                                     <button
//                                         className="w-full bg-red-50 hover:bg-red-100 text-red-700 font-custom-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2">
//                                         <ExternalLink className="w-4 h-4"/>
//                                         View on Maps
//                                     </button>
//                                 </div>
//                             </div>
//
//                             {/* Operating Hours */}
//                             <div className="bg-white rounded-xl shadow-sm p-6">
//                                 <h3 className="text-lg font-custom-bold text-gray-900 mb-4">Operating Hours</h3>
//                                 <div className="space-y-2">
//                                     {Object.entries(entityData.operatingHours).map(([day, hours]) => (
//                                         <div key={day} className={`flex justify-between items-center py-2 ${
//                                             day === getCurrentDay() ? 'bg-blue-50 px-3 rounded-lg font-custom-medium' : ''
//                                         }`}>
//                                             <span className="capitalize text-gray-700">{day}</span>
//                                             <span
//                                                 className={`text-sm ${hours === 'Closed' ? 'text-red-600' : 'text-gray-600'}`}>
//                           {hours}
//                         </span>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//
//                             {/* Quick Stats */}
//                             <div className="bg-white rounded-xl shadow-sm p-6">
//                                 <h3 className="text-lg font-custom-bold text-gray-900 mb-4">Quick Info</h3>
//                                 <div className="grid grid-cols-2 gap-4">
//                                     <div className="text-center p-3 bg-blue-50 rounded-lg">
//                                         <Users className="w-6 h-6 text-blue-600 mx-auto mb-1"/>
//                                         <p className="text-2xl font-custom-bold text-blue-700">{entityData.reviewCount}</p>
//                                         <p className="text-xs text-gray-600">Reviews</p>
//                                     </div>
//                                     <div className="text-center p-3 bg-green-50 rounded-lg">
//                                         <Award className="w-6 h-6 text-green-600 mx-auto mb-1"/>
//                                         <p className="text-2xl font-custom-bold text-green-700">{entityData.rating}</p>
//                                         <p className="text-xs text-gray-600">Rating</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// import React, {useState} from 'react';
// import {
// 	Award,
// 	BadgePercent,
// 	Camera,
// 	CheckCircle,
// 	ChevronLeft,
// 	ChevronRight,
// 	Clock,
// 	Heart,
// 	Mail,
// 	MapPin,
// 	MessageCircle,
// 	Phone,
// 	Share2,
// 	Star,
// 	Store,
// 	Tag,
// 	Users
// } from 'lucide-react';
// import {Header} from "../components/Header";
//
// // --- ISOLATED GALLERY COMPONENT ---
// // This prevents the main page from re-rendering when you switch images.
// const GalleryComponent = ({images}) => {
// 	const [currentIndex, setCurrentIndex] = useState(0);
//
// 	const nextImage = (e) => {
// 		e.stopPropagation();
// 		setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
// 	};
//
// 	const prevImage = (e) => {
// 		e.stopPropagation();
// 		setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
// 	};
//
// 	return (
// 		<div className="relative w-full h-full group bg-gray-100">
// 			{/* IMAGE STACKING STRATEGY:
//                Render ALL images at once, absolutely positioned.
//                Use CSS opacity to fade between them.
//                This stops the "white flicker" of loading a new src.
//             */}
// 			{images.map((img, idx) => (
// 				<div
// 					key={idx}
// 					className={`absolute inset-0 w-full h-full transition-opacity duration-500 ease-in-out ${
// 						idx === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
// 					}`}
// 				>
// 					<img
// 						src={img}
// 						alt={`Gallery ${idx}`}
// 						className="w-full h-full object-cover"
// 					/>
// 					{/* Dark Gradient Overlay for text readability if needed */}
// 					<div
// 						className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60"/>
// 				</div>
// 			))}
//
// 			{/* Navigation Controls */}
// 			{images.length > 1 && (
// 				<>
// 					<button
// 						onClick={prevImage}
// 						className="absolute left-3 top-1/2 -translate-y-1/2 p-2 bg-white/20 backdrop-blur-md rounded-full text-white hover:bg-white/40 opacity-0 group-hover:opacity-100 transition-all z-20"
// 					>
// 						<ChevronLeft className="w-5 h-5"/>
// 					</button>
// 					<button
// 						onClick={nextImage}
// 						className="absolute right-3 top-1/2 -translate-y-1/2 p-2 bg-white/20 backdrop-blur-md rounded-full text-white hover:bg-white/40 opacity-0 group-hover:opacity-100 transition-all z-20"
// 					>
// 						<ChevronRight className="w-5 h-5"/>
// 					</button>
//
// 					{/* Dots Indicator */}
// 					<div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 z-20">
// 						{images.map((_, idx) => (
// 							<div
// 								key={idx}
// 								onClick={() => setCurrentIndex(idx)}
// 								className={`h-1.5 rounded-full cursor-pointer transition-all shadow-sm ${
// 									idx === currentIndex
// 										? 'bg-white w-4'
// 										: 'bg-white/50 hover:bg-white/80 w-1.5'
// 								}`}
// 							/>
// 						))}
// 					</div>
//
// 					<div className="absolute bottom-3 right-3 px-3 py-1 bg-black/50 backdrop-blur-md rounded-full z-20">
// 						<div className="flex items-center gap-1.5">
// 							<Camera className="w-3 h-3 text-white"/>
// 							<span className="text-[10px] font-custom-bold text-white tracking-wider">
// 					            {currentIndex + 1} / {images.length}
// 					        </span>
// 						</div>
// 					</div>
// 				</>
// 			)}
// 		</div>
// 	);
// };
//
// export const YellowPageEntityPublicProfile = () => {
// 	// Removed top-level state: const [currentImageIndex, setCurrentImageIndex] = useState(0);
//
// 	// Sample data
// 	const entityData = {
// 		type: 'Business Entity',
// 		subType: 'Both',
// 		name: 'TechFix Solutions',
// 		ownerName: 'Rajesh Kumar',
// 		category: 'Electronics & Electrical',
// 		area: 'Bhayandar West',
// 		pinCode: '401101',
// 		address: 'Shop No. 15, Maxus Mall, Near Railway Station, Bhayandar West',
// 		mobile: '+91 98765 43210',
// 		whatsapp: '+91 98765 43210',
// 		email: 'info@techfixsolutions.com',
// 		experience: '5-10 years',
// 		description: 'We sell latest mobile phones, laptops, and electronic gadgets. We also provide professional repair services for all brands of smartphones, laptops, and electronic devices with genuine spare parts and warranty. Our technicians are certified and we offer a 3-month warranty on all repairs.',
// 		images: [
// 			'/assets/tech-filler-1.png',
// 			'/assets/tech-filler-2.png',
// 			'/assets/tech-filler-3.png'
// 		],
// 		featuredItems: [
// 			{
// 				name: "iPhone Screen Replacement",
// 				price: "₹1,500 - ₹8,000",
// 				image: "/assets/tech-filler-1.png",
// 				tag: "Service"
// 			},
// 			{
// 				name: "Samsung Galaxy S23 Ultra",
// 				price: "₹1,24,999",
// 				image: "/assets/tech-filler-2.png",
// 				tag: "Product"
// 			},
// 			{
// 				name: "Laptop SSD Upgrade",
// 				price: "From ₹2,500",
// 				image: "/assets/tech-filler-3.png",
// 				tag: "Service"
// 			}
// 		],
// 		rating: 4.6,
// 		reviewCount: 127,
// 		isVerified: true,
// 		operatingHours: {
// 			monday: '9:00 AM - 8:00 PM',
// 			tuesday: '9:00 AM - 8:00 PM',
// 			wednesday: '9:00 AM - 8:00 PM',
// 			thursday: '9:00 AM - 8:00 PM',
// 			friday: '9:00 AM - 8:00 PM',
// 			saturday: '9:00 AM - 8:00 PM',
// 			sunday: '10:00 AM - 6:00 PM'
// 		},
// 		services: [
// 			'Mobile Phone Sales',
// 			'Laptop Sales',
// 			'Screen Repair',
// 			'Battery Replacement',
// 			'Software Installation',
// 			'Data Recovery',
// 			'Chip Level Service'
// 		],
// 		specialOffers: [
// 			'Free screen guard with every phone purchase',
// 			'10% discount on repair services for students',
// 			'Extended warranty available'
// 		]
// 	};
//
// 	const getCurrentDay = () => {
// 		const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
// 		return days[new Date().getDay()];
// 	};
//
// 	const isOpenNow = () => {
// 		const currentHours = entityData.operatingHours[getCurrentDay()];
// 		return currentHours && currentHours !== 'Closed';
// 	};
//
// 	// --- Components ---
//
// 	// Standard Card Container
// 	const BentoCard = ({children, className = ""}) => (
// 		<div
// 			className={`bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col ${className}`}>
// 			{children}
// 		</div>
// 	);
//
// 	// Section Header (Sticky within cards)
// 	const CardHeader = ({title, icon: Icon, action}) => (
// 		<div
// 			className="px-5 py-4 flex items-center justify-between border-b border-gray-100 bg-white sticky top-0 z-10 shrink-0">
// 			<div className="flex items-center gap-2">
// 				{Icon && <Icon className="w-5 h-5 text-orange-500"/>}
// 				<h3 className="font-custom-bold text-gray-800 text-lg">{title}</h3>
// 			</div>
// 			{action}
// 		</div>
// 	);
//
// 	return (
// 		<div className="min-h-screen w-full bg-[#F7F7F7] relative flex flex-col items-center">
// 			<Header/>
//
// 			{/* MAIN LAYOUT CONTAINER (4K Optimized) */}
// 			<main className={`
//                 w-full
//                 2xl:max-w-[1600px]
//                 mx-auto
//                 bg-[#F7F7F7]
//
//                 /* --- Mobile Styling --- */
//                 flex flex-col gap-4
//                 min-h-screen
//                 px-3 pb-4
//
//                 /* Header Offset */
//                 portrait:pt-[4.75rem]
//                 portrait:sm:pt-[6.25rem]
//                 portrait:jk:pt-[5.75rem]
//                 landscape:pt-[3.5rem]
//                 landscape:jk:pt-[4.5rem]
//
//                 /* --- Desktop Styling (Bento Grid) --- */
//                 lg:h-screen lg:overflow-hidden
//                 lg:pt-[4.5rem] lg:pb-6 lg:px-6
//                 lg:grid lg:grid-cols-12 lg:gap-6
//             `}>
//
// 				{/* -----------------------------
//                    COLUMN 1: IDENTITY (Left)
//                    ----------------------------- */}
// 				<div className="lg:col-span-3 lg:h-full lg:overflow-hidden">
// 					<BentoCard className="h-fit lg:h-full">
// 						{/* Profile Header Area */}
// 						<div
// 							className="p-6 flex flex-col items-center text-center bg-gradient-to-b from-orange-50/50 to-white shrink-0">
// 							{/* Actions (Top Right) */}
// 							<div className="w-full flex justify-between items-start mb-2">
// 								<div className="p-2"></div>
// 								<div className="flex gap-2">
// 									<button
// 										className="p-2 rounded-full bg-white shadow-sm hover:bg-gray-50 text-gray-400 hover:text-red-500 transition-colors">
// 										<Heart className="w-5 h-5"/>
// 									</button>
// 									<button
// 										className="p-2 rounded-full bg-white shadow-sm hover:bg-gray-50 text-gray-400 hover:text-blue-500 transition-colors">
// 										<Share2 className="w-5 h-5"/>
// 									</button>
// 								</div>
// 							</div>
//
// 							{/* Image */}
// 							<div className="relative mb-4">
// 								<div className="w-32 h-32 p-1 bg-white rounded-full shadow-md">
// 									<img
// 										src={entityData.images[0]}
// 										alt="Profile"
// 										className="w-full h-full object-cover rounded-full"
// 									/>
// 								</div>
// 								{entityData.isVerified && (
// 									<div className="absolute bottom-1 right-1 bg-white p-1 rounded-full shadow-sm">
// 										<CheckCircle className="w-6 h-6 text-blue-500 fill-white"/>
// 									</div>
// 								)}
// 							</div>
//
// 							<h1 className="text-2xl font-custom-bold text-gray-900 leading-tight mb-1">
// 								{entityData.name}
// 							</h1>
// 							<p className="text-sm text-gray-500 font-custom-medium mb-4">
// 								({entityData.ownerName})
// 							</p>
//
// 							<div className="flex flex-wrap justify-center gap-2 mb-6">
//                                 <span
// 	                                className="px-3 py-1 bg-blue-50 text-blue-700 text-xs font-custom-bold rounded-full border border-blue-100">
//                                     {entityData.category}
//                                 </span>
// 								<div
// 									className="flex items-center gap-1 px-3 py-1 bg-yellow-50 text-yellow-700 text-xs font-custom-bold rounded-full border border-yellow-100">
// 									<Star className="w-3 h-3 fill-yellow-500 text-yellow-500"/>
// 									<span>{entityData.rating}</span>
// 								</div>
// 							</div>
//
// 							{/* Action Buttons */}
// 							<div className="grid grid-cols-2 gap-3 w-full">
// 								<a href={`tel:${entityData.mobile}`}
// 								   className="flex items-center justify-center gap-2 p-3 bg-green-500 hover:bg-green-600 text-white rounded-xl transition-colors shadow-sm shadow-green-200">
// 									<Phone className="w-4 h-4"/>
// 									<span className="font-custom-bold text-sm">Call</span>
// 								</a>
// 								<a href={`https://wa.me/${entityData.whatsapp}`}
// 								   className="flex items-center justify-center gap-2 p-3 bg-white border border-green-500 text-green-600 hover:bg-green-50 rounded-xl transition-colors">
// 									<MessageCircle className="w-4 h-4"/>
// 									<span className="font-custom-bold text-sm">WhatsApp</span>
// 								</a>
// 							</div>
// 						</div>
//
// 						{/* Scrollable Details Section */}
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-6 border-t border-gray-100 bg-white">
// 							<h4 className="text-xs font-custom-bold text-gray-400 uppercase tracking-wider mb-4">Contact
// 								Details</h4>
//
// 							<div className="space-y-5">
// 								<div className="flex gap-3 items-start group cursor-pointer">
// 									<div
// 										className="p-2 bg-gray-50 rounded-lg group-hover:bg-orange-50 transition-colors">
// 										<MapPin className="w-5 h-5 text-gray-400 group-hover:text-orange-500"/>
// 									</div>
// 									<div>
// 										<p className="text-sm text-gray-800 font-custom-bold leading-tight mb-1">Address</p>
// 										<p className="text-sm text-gray-500 leading-snug">{entityData.address}</p>
// 										<p className="text-xs text-gray-400 mt-1">{entityData.area} - {entityData.pinCode}</p>
// 									</div>
// 								</div>
//
// 								<div className="flex gap-3 items-center group">
// 									<div className="p-2 bg-gray-50 rounded-lg group-hover:bg-blue-50 transition-colors">
// 										<Mail className="w-5 h-5 text-gray-400 group-hover:text-blue-500"/>
// 									</div>
// 									<div className="overflow-hidden">
// 										<p className="text-sm text-gray-800 font-custom-bold leading-tight">Email</p>
// 										<p className="text-sm text-gray-500 truncate">{entityData.email}</p>
// 									</div>
// 								</div>
//
// 								<div className="flex gap-3 items-center group">
// 									<div
// 										className="p-2 bg-gray-50 rounded-lg group-hover:bg-purple-50 transition-colors">
// 										<Award className="w-5 h-5 text-gray-400 group-hover:text-purple-500"/>
// 									</div>
// 									<div>
// 										<p className="text-sm text-gray-800 font-custom-bold leading-tight">Experience</p>
// 										<p className="text-sm text-gray-500">{entityData.experience}</p>
// 									</div>
// 								</div>
// 							</div>
// 						</div>
// 					</BentoCard>
// 				</div>
//
// 				{/* -----------------------------
//                    COLUMN 2: INFO (Middle)
//                    ----------------------------- */}
// 				<div className="lg:col-span-5 lg:h-full lg:overflow-hidden flex flex-col gap-4 lg:gap-6">
//
// 					{/* Top: Gallery (Fixed Height) - NOW USES ISOLATED COMPONENT */}
// 					<BentoCard className="h-64 lg:h-[40%] shrink-0 relative overflow-hidden">
// 						<GalleryComponent images={entityData.images}/>
// 					</BentoCard>
//
// 					{/* Bottom: About, Offerings & Services */}
// 					<BentoCard className="flex-1 h-fit lg:h-auto">
// 						<CardHeader title="About & Offerings" icon={Store}/>
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-5 space-y-8">
//
// 							{/* Description */}
// 							<div className="prose prose-sm max-w-none">
// 								<p className="text-gray-600 leading-relaxed font-custom-medium">
// 									{entityData.description}
// 								</p>
// 							</div>
//
// 							{/* Featured Highlights (Showcase) */}
// 							<div>
// 								<h4 className="text-sm font-custom-bold text-gray-800 mb-4 flex items-center gap-2">
// 									<Tag className="w-4 h-4 text-orange-500"/>
// 									Featured Highlights
// 								</h4>
// 								<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
// 									{entityData.featuredItems.map((item, idx) => (
// 										<div key={idx}
// 										     className="bg-gray-50 rounded-xl p-3 border border-gray-100 hover:border-orange-200 transition-colors group cursor-default">
// 											<div
// 												className="aspect-video w-full bg-white rounded-lg mb-2 overflow-hidden">
// 												<img src={item.image} alt={item.name}
// 												     className="w-full h-full object-cover group-hover:scale-105 transition-transform"/>
// 											</div>
// 											<p className="text-xs font-custom-bold text-orange-600 mb-0.5">{item.tag}</p>
// 											<h5 className="font-custom-bold text-gray-800 text-sm leading-tight mb-1 line-clamp-1">{item.name}</h5>
// 											<p className="text-xs text-gray-500 font-custom-medium">{item.price}</p>
// 										</div>
// 									))}
// 								</div>
// 							</div>
//
// 							{/* Key Services (Chips) */}
// 							<div>
// 								<h4 className="text-sm font-custom-bold text-gray-800 mb-3 flex items-center gap-2">
// 									<BadgePercent className="w-4 h-4 text-orange-500"/>
// 									Key Services
// 								</h4>
// 								<div className="flex flex-wrap gap-2">
// 									{entityData.services.map((service, idx) => (
// 										<span key={idx}
// 										      className="px-3 py-1.5 bg-white text-gray-700 text-xs font-custom-bold rounded-lg border border-gray-200 shadow-sm hover:border-orange-200 hover:text-orange-700 transition-colors cursor-default">
//                                             {service}
//                                         </span>
// 									))}
// 								</div>
// 							</div>
// 						</div>
// 					</BentoCard>
// 				</div>
//
// 				{/* -----------------------------
//                    COLUMN 3: STATS (Right)
//                    ----------------------------- */}
// 				<div className="lg:col-span-4 lg:h-full lg:overflow-hidden flex flex-col gap-4 lg:gap-6">
//
// 					{/* Top: Operating Hours */}
// 					<BentoCard className="h-fit lg:h-[50%]">
// 						<CardHeader
// 							title="Operating Hours"
// 							icon={Clock}
// 							action={
// 								<span
// 									className={`px-2.5 py-1 rounded-md text-[10px] uppercase font-custom-bold tracking-wide ${isOpenNow() ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
//                                     {isOpenNow() ? 'Open' : 'Closed'}
//                                 </span>
// 							}
// 						/>
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-2">
// 							{Object.entries(entityData.operatingHours).map(([day, hours]) => (
// 								<div
// 									key={day}
// 									className={`flex justify-between items-center p-3 rounded-lg mb-1 transition-colors ${day === getCurrentDay() ? 'bg-blue-50 border border-blue-100' : 'hover:bg-gray-50'}`}
// 								>
//                                     <span
// 	                                    className={`capitalize text-sm font-custom-medium ${day === getCurrentDay() ? 'text-blue-700' : 'text-gray-600'}`}>
//                                         {day}
//                                     </span>
// 									<span
// 										className={`text-xs font-custom-bold ${hours === 'Closed' ? 'text-red-500' : 'text-gray-700'}`}>
//                                         {hours}
//                                     </span>
// 								</div>
// 							))}
// 						</div>
// 					</BentoCard>
//
// 					{/* Bottom: Highlights/Offers */}
// 					<BentoCard className="flex-1 h-fit lg:h-auto">
// 						<CardHeader title="Highlights" icon={Award}/>
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-5">
//
// 							{/* Stats Grid */}
// 							<div className="grid grid-cols-2 gap-3 mb-6">
// 								<div className="bg-orange-50 rounded-2xl p-4 text-center border border-orange-100">
// 									<Users className="w-5 h-5 text-orange-500 mx-auto mb-2"/>
// 									<p className="text-xl font-custom-bold text-gray-800 leading-none mb-1">{entityData.reviewCount}</p>
// 									<p className="text-[10px] uppercase tracking-wider text-gray-500 font-custom-bold">Reviews</p>
// 								</div>
// 								<div className="bg-blue-50 rounded-2xl p-4 text-center border border-blue-100">
// 									<Star className="w-5 h-5 text-blue-500 mx-auto mb-2"/>
// 									<p className="text-xl font-custom-bold text-gray-800 leading-none mb-1">{entityData.rating}</p>
// 									<p className="text-[10px] uppercase tracking-wider text-gray-500 font-custom-bold">Rating</p>
// 								</div>
// 							</div>
//
// 							{/* Offers List */}
// 							<div>
// 								<h4 className="text-xs font-custom-bold text-gray-400 uppercase tracking-wider mb-3">Special
// 									Offers</h4>
// 								<div className="space-y-2.5">
// 									{entityData.specialOffers.map((offer, idx) => (
// 										<div key={idx}
// 										     className="flex items-start gap-3 text-sm bg-green-50/50 p-3 rounded-xl border border-green-100 hover:border-green-200 transition-colors">
// 											<BadgePercent className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5"/>
// 											<span
// 												className="text-gray-700 font-custom-medium leading-tight">{offer}</span>
// 										</div>
// 									))}
// 								</div>
// 							</div>
//
// 						</div>
// 					</BentoCard>
// 				</div>
//
// 			</main>
// 		</div>
// 	);
// };

// import React, {useState} from 'react';
// import {
// 	Award,
// 	BadgePercent,
// 	CheckCircle,
// 	ChevronDown,
// 	ChevronLeft,
// 	ChevronRight,
// 	ChevronUp,
// 	Clock,
// 	Eye,
// 	Heart,
// 	Mail,
// 	MapPin,
// 	MessageCircle,
// 	Phone,
// 	Share2,
// 	Store,
// 	Tag
// } from 'lucide-react';
// import {Header} from "../components/Header";
//
// // --- ISOLATED GALLERY COMPONENT ---
// const GalleryComponent = ({images}) => {
// 	const [currentIndex, setCurrentIndex] = useState(0);
//
// 	const nextImage = (e) => {
// 		e.stopPropagation();
// 		setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
// 	};
//
// 	const prevImage = (e) => {
// 		e.stopPropagation();
// 		setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
// 	};
//
// 	return (
// 		<div className="relative w-full h-full group bg-gray-100">
// 			{images.map((img, idx) => (
// 				<div
// 					key={idx}
// 					className={`absolute inset-0 w-full h-full transition-opacity duration-500 ease-in-out ${
// 						idx === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
// 					}`}
// 				>
// 					<img
// 						src={img}
// 						alt={`Gallery ${idx}`}
// 						className="w-full h-full object-cover"
// 					/>
// 					<div
// 						className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60"/>
// 				</div>
// 			))}
//
// 			{images.length > 1 && (
// 				<>
// 					<button
// 						onClick={prevImage}
// 						className="absolute left-3 top-1/2 -translate-y-1/2 p-2 bg-white/20 backdrop-blur-md rounded-full text-white hover:bg-white/40 opacity-0 group-hover:opacity-100 transition-all z-20"
// 					>
// 						<ChevronLeft className="w-5 h-5"/>
// 					</button>
// 					<button
// 						onClick={nextImage}
// 						className="absolute right-3 top-1/2 -translate-y-1/2 p-2 bg-white/20 backdrop-blur-md rounded-full text-white hover:bg-white/40 opacity-0 group-hover:opacity-100 transition-all z-20"
// 					>
// 						<ChevronRight className="w-5 h-5"/>
// 					</button>
//
// 					<div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 z-20">
// 						{images.map((_, idx) => (
// 							<div
// 								key={idx}
// 								onClick={() => setCurrentIndex(idx)}
// 								className={`h-1.5 rounded-full cursor-pointer transition-all shadow-sm ${
// 									idx === currentIndex
// 										? 'bg-white w-4'
// 										: 'bg-white/50 hover:bg-white/80 w-1.5'
// 								}`}
// 							/>
// 						))}
// 					</div>
// 				</>
// 			)}
// 		</div>
// 	);
// };
//
// // --- ISOLATED OPERATING HOURS COMPONENT (The Fix) ---
// const OperatingHoursComponent = ({operatingHours, isOpenNow, getCurrentDay}) => {
// 	const [isExpanded, setIsExpanded] = useState(false);
// 	const currentDay = getCurrentDay();
// 	const todayHours = operatingHours[currentDay];
//
// 	return (
// 		<div className="flex flex-col h-full">
// 			{/* Header: Shows Status + Today's Time */}
// 			<div className="p-4 bg-gray-50 rounded-xl border border-gray-100 mb-2">
// 				<div className="flex justify-between items-center mb-2">
// 					<div className="flex items-center gap-2">
// 						<Clock className="w-5 h-5 text-gray-500"/>
// 						<span className="font-custom-bold text-gray-700 text-sm">Today</span>
// 					</div>
// 					<span
// 						className={`px-2.5 py-0.5 rounded-md text-[10px] uppercase font-custom-bold tracking-wide ${isOpenNow() ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
//                         {isOpenNow() ? 'Open Now' : 'Closed'}
//                     </span>
// 				</div>
// 				<p className="text-lg font-custom-bold text-gray-900">{todayHours}</p>
// 			</div>
//
// 			{/* Toggle Button */}
// 			<button
// 				onClick={() => setIsExpanded(!isExpanded)}
// 				className="flex items-center justify-between w-full px-2 py-2 text-xs font-custom-semi-bold text-gray-500 hover:text-orange-600 transition-colors"
// 			>
// 				<span>{isExpanded ? "Hide Full Week" : "View Full Week"}</span>
// 				{isExpanded ? <ChevronUp className="w-4 h-4"/> : <ChevronDown className="w-4 h-4"/>}
// 			</button>
//
// 			{/* Expandable List */}
// 			{isExpanded && (
// 				<div
// 					className="flex-1 overflow-y-auto thin-scrollbar mt-2 space-y-1 pr-2 animate-in fade-in slide-in-from-top-2 duration-200">
// 					{Object.entries(operatingHours).map(([day, hours]) => (
// 						<div
// 							key={day}
// 							className={`flex justify-between items-center p-2 rounded-lg text-xs ${day === currentDay ? 'bg-orange-50 text-orange-800 font-custom-bold' : 'text-gray-600 hover:bg-gray-50'}`}
// 						>
// 							<span className="capitalize">{day}</span>
// 							<span>{hours}</span>
// 						</div>
// 					))}
// 				</div>
// 			)}
// 		</div>
// 	);
// };
//
// export const YellowPageEntityPublicProfile = () => {
// 	// Replaced Reviews/Ratings with Endorsements/Views
// 	const [endorsementCount, setEndorsementCount] = useState(142); // "Likes"
// 	const [isEndorsed, setIsEndorsed] = useState(false);
//
// 	// Sample data
// 	const entityData = {
// 		type: 'Business Entity',
// 		subType: 'Both',
// 		name: 'TechFix Solutions',
// 		ownerName: 'Rajesh Kumar',
// 		category: 'Electronics & Electrical',
// 		area: 'Bhayandar West',
// 		pinCode: '401101',
// 		address: 'Shop No. 15, Maxus Mall, Near Railway Station, Bhayandar West',
// 		mobile: '+91 98765 43210',
// 		whatsapp: '+91 98765 43210',
// 		email: 'info@techfixsolutions.com',
// 		experience: '5-10 years',
// 		description: 'We sell latest mobile phones, laptops, and electronic gadgets. We also provide professional repair services for all brands of smartphones, laptops, and electronic devices with genuine spare parts and warranty. Our technicians are certified and we offer a 3-month warranty on all repairs.',
// 		images: [
// 			'/assets/tech-filler-1.png',
// 			'/assets/tech-filler-2.png',
// 			'/assets/tech-filler-3.png'
// 		],
// 		featuredItems: [
// 			{
// 				name: "iPhone Screen Replacement",
// 				price: "₹1,500 - ₹8,000",
// 				image: "/assets/tech-filler-1.png",
// 				tag: "Service"
// 			},
// 			{
// 				name: "Samsung Galaxy S23 Ultra",
// 				price: "₹1,24,999",
// 				image: "/assets/tech-filler-2.png",
// 				tag: "Product"
// 			},
// 			{
// 				name: "Laptop SSD Upgrade",
// 				price: "From ₹2,500",
// 				image: "/assets/tech-filler-3.png",
// 				tag: "Service"
// 			}
// 		],
// 		// UPDATED METRICS
// 		views: 1205, // Neutral metric
// 		isVerified: true,
// 		operatingHours: {
// 			monday: '9:00 AM - 8:00 PM',
// 			tuesday: '9:00 AM - 8:00 PM',
// 			wednesday: '9:00 AM - 8:00 PM',
// 			thursday: '9:00 AM - 8:00 PM',
// 			friday: '9:00 AM - 8:00 PM',
// 			saturday: '9:00 AM - 8:00 PM',
// 			sunday: '10:00 AM - 6:00 PM'
// 		},
// 		services: [
// 			'Mobile Phone Sales',
// 			'Laptop Sales',
// 			'Screen Repair',
// 			'Battery Replacement',
// 			'Software Installation',
// 			'Data Recovery',
// 			'Chip Level Service'
// 		],
// 		specialOffers: [
// 			'Free screen guard with every phone purchase',
// 			'10% discount on repair services for students',
// 			'Extended warranty available'
// 		]
// 	};
//
// 	const getCurrentDay = () => {
// 		const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
// 		return days[new Date().getDay()];
// 	};
//
// 	const isOpenNow = () => {
// 		const currentHours = entityData.operatingHours[getCurrentDay()];
// 		return currentHours && currentHours !== 'Closed';
// 	};
//
// 	const handleEndorse = () => {
// 		setIsEndorsed(!isEndorsed);
// 		setEndorsementCount(prev => isEndorsed ? prev - 1 : prev + 1);
// 	};
//
// 	// --- Components ---
//
// 	const BentoCard = ({children, className = ""}) => (
// 		<div
// 			className={`bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col ${className}`}>
// 			{children}
// 		</div>
// 	);
//
// 	const CardHeader = ({title, icon: Icon, action}) => (
// 		<div
// 			className="px-5 py-4 flex items-center justify-between border-b border-gray-100 bg-white sticky top-0 z-10 shrink-0">
// 			<div className="flex items-center gap-2">
// 				{Icon && <Icon className="w-5 h-5 text-orange-500"/>}
// 				<h3 className="font-custom-bold text-gray-800 text-lg">{title}</h3>
// 			</div>
// 			{action}
// 		</div>
// 	);
//
// 	return (
// 		<div className="min-h-screen w-full bg-[#F7F7F7] relative flex flex-col items-center">
// 			<Header/>
//
// 			<main className={`
//                 w-full 2xl:max-w-[1600px] mx-auto bg-[#F7F7F7]
//                 flex flex-col gap-4 min-h-screen px-3 pb-4
//                 portrait:pt-[4.75rem] portrait:sm:pt-[6.25rem] portrait:jk:pt-[5.75rem]
//                 landscape:pt-[3.5rem] landscape:jk:pt-[4.5rem]
//                 lg:h-screen lg:overflow-hidden lg:pt-[4.5rem] lg:pb-6 lg:px-6 lg:grid lg:grid-cols-12 lg:gap-6
//             `}>
//
// 				{/* --- COLUMN 1: IDENTITY (Left) --- */}
// 				<div className="lg:col-span-3 lg:h-full lg:overflow-hidden">
// 					<BentoCard className="h-fit lg:h-full">
// 						<div
// 							className="p-6 flex flex-col items-center text-center bg-gradient-to-b from-orange-50/50 to-white shrink-0">
// 							<div className="w-full flex justify-between items-start mb-2">
// 								<div className="p-2"></div>
// 								<div className="flex gap-2">
// 									<button
// 										className="p-2 rounded-full bg-white shadow-sm hover:bg-gray-50 text-gray-400 hover:text-blue-500 transition-colors">
// 										<Share2 className="w-5 h-5"/>
// 									</button>
// 								</div>
// 							</div>
// 							<div className="relative mb-4">
// 								<div className="w-32 h-32 p-1 bg-white rounded-full shadow-md">
// 									<img src={entityData.images[0]} alt="Profile"
// 									     className="w-full h-full object-cover rounded-full"/>
// 								</div>
// 								{entityData.isVerified && (
// 									<div className="absolute bottom-1 right-1 bg-white p-1 rounded-full shadow-sm">
// 										<CheckCircle className="w-6 h-6 text-blue-500 fill-white"/>
// 									</div>
// 								)}
// 							</div>
// 							<h1 className="text-2xl font-custom-bold text-gray-900 leading-tight mb-1">{entityData.name}</h1>
// 							<p className="text-sm text-gray-500 font-custom-medium mb-4">({entityData.ownerName})</p>
//
// 							{/* Updated Badge: Replaced Rating with Verified/Category */}
// 							<span
// 								className="px-3 py-1 bg-blue-50 text-blue-700 text-xs font-custom-bold rounded-full border border-blue-100 mb-6">
//                                 {entityData.category}
//                             </span>
//
// 							<div className="grid grid-cols-2 gap-3 w-full">
// 								<a href={`tel:${entityData.mobile}`}
// 								   className="flex items-center justify-center gap-2 p-3 bg-green-500 hover:bg-green-600 text-white rounded-xl transition-colors shadow-sm shadow-green-200">
// 									<Phone className="w-4 h-4"/>
// 									<span className="font-custom-bold text-sm">Call</span>
// 								</a>
// 								<a href={`https://wa.me/${entityData.whatsapp}`}
// 								   className="flex items-center justify-center gap-2 p-3 bg-white border border-green-500 text-green-600 hover:bg-green-50 rounded-xl transition-colors">
// 									<MessageCircle className="w-4 h-4"/>
// 									<span className="font-custom-bold text-sm">WhatsApp</span>
// 								</a>
// 							</div>
// 						</div>
//
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-6 border-t border-gray-100 bg-white">
// 							<h4 className="text-xs font-custom-bold text-gray-400 uppercase tracking-wider mb-4">Contact
// 								Details</h4>
// 							<div className="space-y-5">
// 								<div className="flex gap-3 items-start group cursor-pointer">
// 									<div
// 										className="p-2 bg-gray-50 rounded-lg group-hover:bg-orange-50 transition-colors">
// 										<MapPin className="w-5 h-5 text-gray-400 group-hover:text-orange-500"/>
// 									</div>
// 									<div>
// 										<p className="text-sm text-gray-800 font-custom-bold leading-tight mb-1">Address</p>
// 										<p className="text-sm text-gray-500 leading-snug">{entityData.address}</p>
// 										<p className="text-xs text-gray-400 mt-1">{entityData.area} - {entityData.pinCode}</p>
// 									</div>
// 								</div>
// 								<div className="flex gap-3 items-center group">
// 									<div className="p-2 bg-gray-50 rounded-lg group-hover:bg-blue-50 transition-colors">
// 										<Mail className="w-5 h-5 text-gray-400 group-hover:text-blue-500"/>
// 									</div>
// 									<div className="overflow-hidden">
// 										<p className="text-sm text-gray-800 font-custom-bold leading-tight">Email</p>
// 										<p className="text-sm text-gray-500 truncate">{entityData.email}</p>
// 									</div>
// 								</div>
// 							</div>
// 						</div>
// 					</BentoCard>
// 				</div>
//
// 				{/* --- COLUMN 2: INFO (Middle) --- */}
// 				<div className="lg:col-span-5 lg:h-full lg:overflow-hidden flex flex-col gap-4 lg:gap-6">
// 					<BentoCard className="h-64 lg:h-[40%] shrink-0 relative overflow-hidden">
// 						<GalleryComponent images={entityData.images}/>
// 					</BentoCard>
//
// 					<BentoCard className="flex-1 h-fit lg:h-auto">
// 						<CardHeader title="About & Offerings" icon={Store}/>
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-5 space-y-8">
// 							<div className="prose prose-sm max-w-none">
// 								<p className="text-gray-600 leading-relaxed font-custom-medium">{entityData.description}</p>
// 							</div>
//
// 							{/* Featured Highlights (Now has more breathing room visually) */}
// 							<div>
// 								<h4 className="text-sm font-custom-bold text-gray-800 mb-4 flex items-center gap-2">
// 									<Tag className="w-4 h-4 text-orange-500"/>
// 									Featured Highlights
// 								</h4>
// 								<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
// 									{entityData.featuredItems.map((item, idx) => (
// 										<div key={idx}
// 										     className="bg-gray-50 rounded-xl p-3 border border-gray-100 hover:border-orange-200 transition-colors group cursor-default">
// 											<div
// 												className="aspect-video w-full bg-white rounded-lg mb-2 overflow-hidden">
// 												<img src={item.image} alt={item.name}
// 												     className="w-full h-full object-cover group-hover:scale-105 transition-transform"/>
// 											</div>
// 											<p className="text-xs font-custom-bold text-orange-600 mb-0.5">{item.tag}</p>
// 											<h5 className="font-custom-bold text-gray-800 text-sm leading-tight mb-1 line-clamp-1">{item.name}</h5>
// 											<p className="text-xs text-gray-500 font-custom-medium">{item.price}</p>
// 										</div>
// 									))}
// 								</div>
// 							</div>
//
// 							<div>
// 								<h4 className="text-sm font-custom-bold text-gray-800 mb-3 flex items-center gap-2">
// 									<BadgePercent className="w-4 h-4 text-orange-500"/>
// 									Key Services
// 								</h4>
// 								<div className="flex flex-wrap gap-2">
// 									{entityData.services.map((service, idx) => (
// 										<span key={idx}
// 										      className="px-3 py-1.5 bg-white text-gray-700 text-xs font-custom-bold rounded-lg border border-gray-200 shadow-sm hover:border-orange-200 hover:text-orange-700 transition-colors cursor-default">
//                                             {service}
//                                         </span>
// 									))}
// 								</div>
// 							</div>
// 						</div>
// 					</BentoCard>
// 				</div>
//
// 				{/* --- COLUMN 3: STATS & HOURS (Right) --- */}
// 				<div className="lg:col-span-4 lg:h-full lg:overflow-hidden flex flex-col gap-4 lg:gap-6">
//
// 					{/* 1. Community Trust (Replaced Reviews with Endorsements) */}
// 					<BentoCard className="h-fit lg:h-auto">
// 						<CardHeader title="Community Trust" icon={Award}/>
// 						<div className="p-5">
// 							{/* New "Safe" Metrics: Endorsements & Views */}
// 							<div className="grid grid-cols-2 gap-3 mb-6">
// 								{/* Endorsements (Interactive) */}
// 								<button
// 									onClick={handleEndorse}
// 									className={`rounded-2xl p-4 text-center border transition-all ${isEndorsed ? 'bg-red-50 border-red-200' : 'bg-gray-50 border-gray-100 hover:bg-red-50 hover:border-red-100'}`}
// 								>
// 									<Heart
// 										className={`w-6 h-6 mx-auto mb-2 transition-colors ${isEndorsed ? 'fill-red-500 text-red-500' : 'text-gray-400'}`}/>
// 									<p className={`text-xl font-custom-bold leading-none mb-1 ${isEndorsed ? 'text-red-600' : 'text-gray-800'}`}>{endorsementCount}</p>
// 									<p className="text-[10px] uppercase tracking-wider text-gray-500 font-custom-bold">Endorsements</p>
// 								</button>
//
// 								{/* Views (Passive) */}
// 								<div
// 									className="bg-blue-50 rounded-2xl p-4 text-center border border-blue-100 cursor-default">
// 									<Eye className="w-6 h-6 text-blue-500 mx-auto mb-2"/>
// 									<p className="text-xl font-custom-bold text-gray-800 leading-none mb-1">{entityData.views}</p>
// 									<p className="text-[10px] uppercase tracking-wider text-gray-500 font-custom-bold">Profile
// 										Views</p>
// 								</div>
// 							</div>
//
// 							<div className="space-y-2.5">
// 								<h4 className="text-xs font-custom-bold text-gray-400 uppercase tracking-wider mb-2">Offers</h4>
// 								{entityData.specialOffers.map((offer, idx) => (
// 									<div key={idx}
// 									     className="flex items-start gap-3 text-sm bg-green-50/50 p-3 rounded-xl border border-green-100 hover:border-green-200 transition-colors">
// 										<BadgePercent className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5"/>
// 										<span className="text-gray-700 font-custom-medium leading-tight">{offer}</span>
// 									</div>
// 								))}
// 							</div>
// 						</div>
// 					</BentoCard>
//
// 					{/* 2. Compact Operating Hours (Moved to Bottom & Collapsible) */}
// 					<BentoCard className="h-fit flex-1 bg-white">
// 						<div className="p-4 h-full">
// 							<OperatingHoursComponent
// 								operatingHours={entityData.operatingHours}
// 								isOpenNow={isOpenNow}
// 								getCurrentDay={getCurrentDay}
// 							/>
// 						</div>
// 					</BentoCard>
//
// 				</div>
// 			</main>
// 		</div>
// 	);
// };

// import React, {useState} from 'react';
// import {
// 	BadgePercent,
// 	CheckCircle,
// 	ChevronDown,
// 	ChevronLeft,
// 	ChevronRight,
// 	ChevronUp,
// 	Clock,
// 	Eye,
// 	Heart,
// 	Mail,
// 	MapPin,
// 	MessageCircle,
// 	Phone,
// 	Share2,
// 	ShoppingBag,
// 	Store,
// 	Tag
// } from 'lucide-react';
// import {Header} from "../components/Header";
//
// // --- ISOLATED GALLERY COMPONENT ---
// const GalleryComponent = ({images}) => {
// 	const [currentIndex, setCurrentIndex] = useState(0);
//
// 	const nextImage = (e) => {
// 		e.stopPropagation();
// 		setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
// 	};
//
// 	const prevImage = (e) => {
// 		e.stopPropagation();
// 		setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
// 	};
//
// 	return (
// 		<div className="relative w-full h-full group bg-gray-100">
// 			{images.map((img, idx) => (
// 				<div
// 					key={idx}
// 					className={`absolute inset-0 w-full h-full transition-opacity duration-500 ease-in-out ${
// 						idx === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
// 					}`}
// 				>
// 					<img
// 						src={img}
// 						alt={`Gallery ${idx}`}
// 						className="w-full h-full object-cover"
// 					/>
// 					<div
// 						className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60"/>
// 				</div>
// 			))}
//
// 			{images.length > 1 && (
// 				<>
// 					<button
// 						onClick={prevImage}
// 						className="absolute left-3 top-1/2 -translate-y-1/2 p-2 bg-white/20 backdrop-blur-md rounded-full text-white hover:bg-white/40 opacity-0 group-hover:opacity-100 transition-all z-20"
// 					>
// 						<ChevronLeft className="w-5 h-5"/>
// 					</button>
// 					<button
// 						onClick={nextImage}
// 						className="absolute right-3 top-1/2 -translate-y-1/2 p-2 bg-white/20 backdrop-blur-md rounded-full text-white hover:bg-white/40 opacity-0 group-hover:opacity-100 transition-all z-20"
// 					>
// 						<ChevronRight className="w-5 h-5"/>
// 					</button>
//
// 					<div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 z-20">
// 						{images.map((_, idx) => (
// 							<div
// 								key={idx}
// 								onClick={() => setCurrentIndex(idx)}
// 								className={`h-1.5 rounded-full cursor-pointer transition-all shadow-sm ${
// 									idx === currentIndex
// 										? 'bg-white w-4'
// 										: 'bg-white/50 hover:bg-white/80 w-1.5'
// 								}`}
// 							/>
// 						))}
// 					</div>
// 				</>
// 			)}
// 		</div>
// 	);
// };
//
// // --- ISOLATED OPERATING HOURS COMPONENT (Compact Version) ---
// const OperatingHoursCompact = ({operatingHours, isOpenNow, getCurrentDay}) => {
// 	const [isExpanded, setIsExpanded] = useState(false);
// 	const currentDay = getCurrentDay();
// 	const todayHours = operatingHours[currentDay];
//
// 	return (
// 		<div className="bg-gray-50 rounded-lg p-3 border border-gray-100 mt-4">
// 			<div
// 				className="flex justify-between items-center cursor-pointer"
// 				onClick={() => setIsExpanded(!isExpanded)}
// 			>
// 				<div>
// 					<div className="flex items-center gap-2 mb-0.5">
// 						<Clock className="w-4 h-4 text-gray-400"/>
// 						<span
// 							className="text-xs font-custom-bold text-gray-500 uppercase tracking-wider">Today's Hours</span>
// 					</div>
// 					<p className="text-sm font-custom-bold text-gray-800">{todayHours}</p>
// 				</div>
// 				<div
// 					className={`p-1.5 rounded-full ${isOpenNow() ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
// 					{isOpenNow() ? <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"/> :
// 						<div className="w-2 h-2 bg-red-500 rounded-full"/>}
// 				</div>
// 			</div>
//
// 			<button
// 				onClick={() => setIsExpanded(!isExpanded)}
// 				className="w-full mt-2 pt-2 border-t border-gray-200 flex items-center justify-center gap-1 text-xs text-gray-500 font-custom-semi-bold hover:text-orange-600 transition-colors"
// 			>
// 				{isExpanded ? "Close Week View" : "View All Days"}
// 				{isExpanded ? <ChevronUp className="w-3 h-3"/> : <ChevronDown className="w-3 h-3"/>}
// 			</button>
//
// 			{isExpanded && (
// 				<div className="mt-2 space-y-1 animate-in slide-in-from-top-2 duration-200">
// 					{Object.entries(operatingHours).map(([day, hours]) => (
// 						<div key={day}
// 						     className={`flex justify-between text-xs ${day === currentDay ? 'text-orange-600 font-custom-bold' : 'text-gray-500'}`}>
// 							<span className="capitalize">{day.slice(0, 3)}</span>
// 							<span>{hours}</span>
// 						</div>
// 					))}
// 				</div>
// 			)}
// 		</div>
// 	);
// };
//
// export const YellowPageEntityPublicProfile = () => {
// 	const [endorsementCount, setEndorsementCount] = useState(142);
// 	const [isEndorsed, setIsEndorsed] = useState(false);
//
// 	// Sample data
// 	const entityData = {
// 		type: 'Business Entity',
// 		subType: 'Both',
// 		name: 'TechFix Solutions',
// 		ownerName: 'Rajesh Kumar',
// 		category: 'Electronics & Electrical',
// 		area: 'Bhayandar West',
// 		pinCode: '401101',
// 		address: 'Shop No. 15, Maxus Mall, Near Railway Station, Bhayandar West',
// 		mobile: '+91 98765 43210',
// 		whatsapp: '+91 98765 43210',
// 		email: 'info@techfixsolutions.com',
// 		experience: '5-10 years',
// 		description: 'We sell latest mobile phones, laptops, and electronic gadgets. We also provide professional repair services for all brands of smartphones, laptops, and electronic devices with genuine spare parts and warranty. Our technicians are certified and we offer a 3-month warranty on all repairs.',
// 		images: [
// 			'/assets/tech-filler-1.png',
// 			'/assets/tech-filler-2.png',
// 			'/assets/tech-filler-3.png'
// 		],
// 		featuredItems: [
// 			{
// 				name: "iPhone Screen Replacement",
// 				price: "₹1,500 - ₹8,000",
// 				image: "/assets/tech-filler-1.png",
// 				tag: "Service"
// 			},
// 			{
// 				name: "Samsung Galaxy S23 Ultra",
// 				price: "₹1,24,999",
// 				image: "/assets/tech-filler-2.png",
// 				tag: "Product"
// 			},
// 			{
// 				name: "Laptop SSD Upgrade",
// 				price: "From ₹2,500",
// 				image: "/assets/tech-filler-3.png",
// 				tag: "Service"
// 			},
// 			{
// 				name: "MacBook Battery Replacement",
// 				price: "₹8,500",
// 				image: "/assets/tech-filler-1.png",
// 				tag: "Service"
// 			},
// 			{
// 				name: "OnePlus Nord CE 3",
// 				price: "₹24,999",
// 				image: "/assets/tech-filler-2.png",
// 				tag: "Product"
// 			}
// 		],
// 		views: 1205,
// 		isVerified: true,
// 		operatingHours: {
// 			monday: '9:00 AM - 8:00 PM',
// 			tuesday: '9:00 AM - 8:00 PM',
// 			wednesday: '9:00 AM - 8:00 PM',
// 			thursday: '9:00 AM - 8:00 PM',
// 			friday: '9:00 AM - 8:00 PM',
// 			saturday: '9:00 AM - 8:00 PM',
// 			sunday: '10:00 AM - 6:00 PM'
// 		},
// 		services: [
// 			'Mobile Phone Sales',
// 			'Laptop Sales',
// 			'Screen Repair',
// 			'Battery Replacement',
// 			'Software Installation',
// 			'Data Recovery',
// 			'Chip Level Service'
// 		],
// 		specialOffers: [
// 			'Free screen guard with every phone purchase',
// 			'10% discount on repair services for students',
// 			'Extended warranty available'
// 		]
// 	};
//
// 	const getCurrentDay = () => {
// 		const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
// 		return days[new Date().getDay()];
// 	};
//
// 	const isOpenNow = () => {
// 		const currentHours = entityData.operatingHours[getCurrentDay()];
// 		return currentHours && currentHours !== 'Closed';
// 	};
//
// 	const handleEndorse = () => {
// 		setIsEndorsed(!isEndorsed);
// 		setEndorsementCount(prev => isEndorsed ? prev - 1 : prev + 1);
// 	};
//
// 	// --- Components ---
//
// 	const BentoCard = ({children, className = ""}) => (
// 		<div
// 			className={`bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col ${className}`}>
// 			{children}
// 		</div>
// 	);
//
// 	const CardHeader = ({title, icon: Icon, action}) => (
// 		<div
// 			className="px-5 py-4 flex items-center justify-between border-b border-gray-100 bg-white sticky top-0 z-10 shrink-0">
// 			<div className="flex items-center gap-2">
// 				{Icon && <Icon className="w-5 h-5 text-orange-500"/>}
// 				<h3 className="font-custom-bold text-gray-800 text-lg">{title}</h3>
// 			</div>
// 			{action}
// 		</div>
// 	);
//
// 	return (
// 		<div className="min-h-screen w-full bg-[#F7F7F7] relative flex flex-col items-center">
// 			<Header/>
//
// 			<main className={`
//                 w-full 2xl:max-w-[1600px] mx-auto bg-[#F7F7F7]
//                 flex flex-col gap-4 min-h-screen px-3 pb-4
//                 portrait:pt-[4.75rem] portrait:sm:pt-[6.25rem] portrait:jk:pt-[5.75rem]
//                 landscape:pt-[3.5rem] landscape:jk:pt-[4.5rem]
//                 lg:h-screen lg:overflow-hidden lg:pt-[4.5rem] lg:pb-6 lg:px-6 lg:grid lg:grid-cols-12 lg:gap-6
//             `}>
//
// 				{/* --- COLUMN 1: IDENTITY & CONTACT (Left) ---
//                     ADDED: Operating Hours here to save space on Right
//                 */}
// 				<div className="lg:col-span-3 lg:h-full lg:overflow-hidden">
// 					<BentoCard className="h-fit lg:h-full">
// 						<div
// 							className="p-6 flex flex-col items-center text-center bg-gradient-to-b from-orange-50/50 to-white shrink-0">
// 							<div className="w-full flex justify-between items-start mb-2">
// 								<div className="p-2"></div>
// 								<div className="flex gap-2">
// 									<button
// 										className="p-2 rounded-full bg-white shadow-sm hover:bg-gray-50 text-gray-400 hover:text-blue-500 transition-colors">
// 										<Share2 className="w-5 h-5"/>
// 									</button>
// 								</div>
// 							</div>
// 							<div className="relative mb-4">
// 								<div className="w-32 h-32 p-1 bg-white rounded-full shadow-md">
// 									<img src={entityData.images[0]} alt="Profile"
// 									     className="w-full h-full object-cover rounded-full"/>
// 								</div>
// 								{entityData.isVerified && (
// 									<div className="absolute bottom-1 right-1 bg-white p-1 rounded-full shadow-sm">
// 										<CheckCircle className="w-6 h-6 text-blue-500 fill-white"/>
// 									</div>
// 								)}
// 							</div>
// 							<h1 className="text-2xl font-custom-bold text-gray-900 leading-tight mb-1">{entityData.name}</h1>
// 							<p className="text-sm text-gray-500 font-custom-medium mb-4">({entityData.ownerName})</p>
//
// 							<span
// 								className="px-3 py-1 bg-blue-50 text-blue-700 text-xs font-custom-bold rounded-full border border-blue-100 mb-6">
//                                 {entityData.category}
//                             </span>
//
// 							<div className="grid grid-cols-2 gap-3 w-full">
// 								<a href={`tel:${entityData.mobile}`}
// 								   className="flex items-center justify-center gap-2 p-3 bg-green-500 hover:bg-green-600 text-white rounded-xl transition-colors shadow-sm shadow-green-200">
// 									<Phone className="w-4 h-4"/>
// 									<span className="font-custom-bold text-sm">Call</span>
// 								</a>
// 								<a href={`https://wa.me/${entityData.whatsapp}`}
// 								   className="flex items-center justify-center gap-2 p-3 bg-white border border-green-500 text-green-600 hover:bg-green-50 rounded-xl transition-colors">
// 									<MessageCircle className="w-4 h-4"/>
// 									<span className="font-custom-bold text-sm">WhatsApp</span>
// 								</a>
// 							</div>
// 						</div>
//
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-6 border-t border-gray-100 bg-white">
// 							<h4 className="text-xs font-custom-bold text-gray-400 uppercase tracking-wider mb-4">Contact
// 								Details</h4>
// 							<div className="space-y-5">
// 								<div className="flex gap-3 items-start group cursor-pointer">
// 									<div
// 										className="p-2 bg-gray-50 rounded-lg group-hover:bg-orange-50 transition-colors">
// 										<MapPin className="w-5 h-5 text-gray-400 group-hover:text-orange-500"/>
// 									</div>
// 									<div>
// 										<p className="text-sm text-gray-800 font-custom-bold leading-tight mb-1">Address</p>
// 										<p className="text-sm text-gray-500 leading-snug">{entityData.address}</p>
// 										<p className="text-xs text-gray-400 mt-1">{entityData.area} - {entityData.pinCode}</p>
// 									</div>
// 								</div>
// 								<div className="flex gap-3 items-center group">
// 									<div className="p-2 bg-gray-50 rounded-lg group-hover:bg-blue-50 transition-colors">
// 										<Mail className="w-5 h-5 text-gray-400 group-hover:text-blue-500"/>
// 									</div>
// 									<div className="overflow-hidden">
// 										<p className="text-sm text-gray-800 font-custom-bold leading-tight">Email</p>
// 										<p className="text-sm text-gray-500 truncate">{entityData.email}</p>
// 									</div>
// 								</div>
// 							</div>
//
// 							{/* MOVED: Operating Hours (Compact) - Fits perfectly under Contact */}
// 							<OperatingHoursCompact
// 								operatingHours={entityData.operatingHours}
// 								isOpenNow={isOpenNow}
// 								getCurrentDay={getCurrentDay}
// 							/>
// 						</div>
// 					</BentoCard>
// 				</div>
//
// 				{/* --- COLUMN 2: INFO (Middle) ---
//                     REMOVED: Featured Highlights from bottom
//                     KEPT: Gallery, About, Services
//                 */}
// 				<div className="lg:col-span-5 lg:h-full lg:overflow-hidden flex flex-col gap-4 lg:gap-6">
// 					<BentoCard className="h-64 lg:h-[40%] shrink-0 relative overflow-hidden">
// 						<GalleryComponent images={entityData.images}/>
// 					</BentoCard>
//
// 					<BentoCard className="flex-1 h-fit lg:h-auto">
// 						<CardHeader title="About & Services" icon={Store}/>
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-5 space-y-6">
//
// 							<div className="prose prose-sm max-w-none">
// 								<p className="text-gray-600 leading-relaxed font-custom-medium">{entityData.description}</p>
// 							</div>
//
// 							<div>
// 								<h4 className="text-sm font-custom-bold text-gray-800 mb-3 flex items-center gap-2">
// 									<BadgePercent className="w-4 h-4 text-orange-500"/>
// 									Key Services
// 								</h4>
// 								<div className="flex flex-wrap gap-2">
// 									{entityData.services.map((service, idx) => (
// 										<span key={idx}
// 										      className="px-3 py-1.5 bg-white text-gray-700 text-xs font-custom-bold rounded-lg border border-gray-200 shadow-sm hover:border-orange-200 hover:text-orange-700 transition-colors cursor-default">
//                                             {service}
//                                         </span>
// 									))}
// 								</div>
// 							</div>
//
// 							<div className="bg-green-50 border border-green-100 rounded-xl p-4">
// 								<h4 className="text-xs font-custom-bold text-green-700 uppercase tracking-wider mb-3">Special
// 									Offers</h4>
// 								<div className="space-y-2.5">
// 									{entityData.specialOffers.map((offer, idx) => (
// 										<div key={idx} className="flex items-start gap-2 text-sm">
// 											<Tag className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5"/>
// 											<span
// 												className="text-gray-700 font-custom-medium leading-tight">{offer}</span>
// 										</div>
// 									))}
// 								</div>
// 							</div>
// 						</div>
// 					</BentoCard>
// 				</div>
//
// 				{/* --- COLUMN 3: SHOWCASE (Right) ---
//                     ADDED: Featured Highlights (The Hero of this column now)
//                     MOVED: Operating hours to Left
//                 */}
// 				<div className="lg:col-span-4 lg:h-full lg:overflow-hidden flex flex-col gap-4 lg:gap-6">
//
// 					{/* 1. Community Trust */}
// 					<BentoCard className="h-fit lg:h-auto shrink-0">
// 						<div className="p-4 grid grid-cols-2 gap-3">
// 							<button
// 								onClick={handleEndorse}
// 								className={`rounded-xl p-3 text-center border transition-all ${isEndorsed ? 'bg-red-50 border-red-200' : 'bg-gray-50 border-gray-100 hover:bg-red-50 hover:border-red-100'}`}
// 							>
// 								<Heart
// 									className={`w-5 h-5 mx-auto mb-1 transition-colors ${isEndorsed ? 'fill-red-500 text-red-500' : 'text-gray-400'}`}/>
// 								<p className={`text-lg font-custom-bold leading-none mb-0.5 ${isEndorsed ? 'text-red-600' : 'text-gray-800'}`}>{endorsementCount}</p>
// 								<p className="text-[10px] uppercase tracking-wider text-gray-500 font-custom-bold">Endorsements</p>
// 							</button>
//
// 							<div
// 								className="bg-blue-50 rounded-xl p-3 text-center border border-blue-100 cursor-default">
// 								<Eye className="w-5 h-5 text-blue-500 mx-auto mb-1"/>
// 								<p className="text-lg font-custom-bold text-gray-800 leading-none mb-0.5">{entityData.views}</p>
// 								<p className="text-[10px] uppercase tracking-wider text-gray-500 font-custom-bold">Views</p>
// 							</div>
// 						</div>
// 					</BentoCard>
//
// 					{/* 2. Featured Highlights (THE SHOWCASE - Vertical Scroll) */}
// 					<BentoCard className="flex-1 h-fit lg:h-auto">
// 						<CardHeader
// 							title="Featured Highlights"
// 							icon={ShoppingBag}
// 							action={<span
// 								className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded-full font-custom-bold">{entityData.featuredItems.length} Items</span>}
// 						/>
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-4 space-y-3">
// 							{entityData.featuredItems.map((item, idx) => (
// 								<div key={idx}
// 								     className="flex gap-3 p-2 rounded-xl border border-gray-100 hover:border-orange-200 hover:shadow-md transition-all bg-white group cursor-default">
// 									{/* Image Left */}
// 									<div className="w-20 h-20 rounded-lg bg-gray-100 overflow-hidden shrink-0">
// 										<img src={item.image} alt={item.name}
// 										     className="w-full h-full object-cover group-hover:scale-105 transition-transform"/>
// 									</div>
//
// 									{/* Content Right */}
// 									<div className="flex-1 flex flex-col justify-center">
// 										<div className="flex justify-between items-start">
//                                             <span
// 	                                            className={`text-[10px] font-custom-bold px-2 py-0.5 rounded-full mb-1 ${item.tag === 'Product' ? 'bg-blue-50 text-blue-600' : 'bg-purple-50 text-purple-600'}`}>
//                                                 {item.tag}
//                                             </span>
// 										</div>
// 										<h5 className="font-custom-bold text-gray-800 text-sm leading-tight mb-1 line-clamp-2">{item.name}</h5>
// 										<p className="text-sm text-orange-600 font-custom-bold">{item.price}</p>
// 									</div>
// 								</div>
// 							))}
//
// 							{/* Upsell / Empty State for Owner (Optional visual) */}
// 							<div className="p-4 text-center border-2 border-dashed border-gray-100 rounded-xl mt-2">
// 								<p className="text-xs text-gray-400 font-custom-medium">Showing
// 									top {entityData.featuredItems.length} highlights</p>
// 							</div>
// 						</div>
// 					</BentoCard>
//
// 				</div>
// 			</main>
// 		</div>
// 	);
// };

// import React, {useState} from 'react';
// import {
// 	Award,
// 	BadgePercent,
// 	CheckCircle,
// 	ChevronDown,
// 	ChevronUp,
// 	Clock,
// 	Eye,
// 	Heart,
// 	Mail,
// 	MapPin,
// 	MessageCircle,
// 	Phone,
// 	ShoppingBag,
// 	Star,
// 	Store,
// 	Wrench
// } from 'lucide-react';
// import {Header} from "../components/Header";
//
// // --- COMPONENT: Operating Hours (Compact & Integrated) ---
// const OperatingHoursCompact = ({operatingHours, isOpenNow, getCurrentDay}) => {
// 	const [isExpanded, setIsExpanded] = useState(false);
// 	if (!operatingHours) return null;
//
// 	const currentDay = getCurrentDay();
// 	const todayHours = operatingHours[currentDay];
//
// 	return (
// 		<div className="mt-6 pt-6 border-t border-gray-100">
// 			<div
// 				className="flex justify-between items-center cursor-pointer group"
// 				onClick={() => setIsExpanded(!isExpanded)}
// 			>
// 				<div className="flex items-center gap-3">
// 					<div
// 						className={`p-2 rounded-lg ${isOpenNow() ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`}>
// 						<Clock className="w-5 h-5"/>
// 					</div>
// 					<div>
// 						<p className="text-xs font-custom-bold text-gray-400 uppercase tracking-wider">Today's Hours</p>
// 						<p className="text-sm font-custom-bold text-gray-800 flex items-center gap-2">
// 							{todayHours}
// 							{isExpanded ? <ChevronUp className="w-3 h-3 text-gray-400"/> :
// 								<ChevronDown className="w-3 h-3 text-gray-400"/>}
// 						</p>
// 					</div>
// 				</div>
// 			</div>
//
// 			{isExpanded && (
// 				<div className="mt-3 bg-gray-50 rounded-lg p-3 space-y-2 animate-in slide-in-from-top-1">
// 					{Object.entries(operatingHours).map(([day, hours]) => (
// 						<div key={day}
// 						     className={`flex justify-between text-xs ${day === currentDay ? 'text-blue-600 font-custom-bold' : 'text-gray-500'}`}>
// 							<span className="capitalize">{day}</span>
// 							<span>{hours}</span>
// 						</div>
// 					))}
// 				</div>
// 			)}
// 		</div>
// 	);
// };
//
// // --- COMPONENT: Featured Highlights (Horizontal Product Slider) ---
// const FeaturedHighlights = ({items}) => {
// 	return (
// 		<div className="w-full mb-6">
// 			<div className="flex items-center justify-between mb-4">
// 				<h3 className="text-lg font-custom-bold text-gray-900 flex items-center gap-2">
// 					<ShoppingBag className="w-5 h-5 text-orange-500"/>
// 					Featured Highlights
// 				</h3>
// 			</div>
// 			{/* Horizontal Scroll Snap Container */}
// 			<div className="flex overflow-x-auto gap-4 pb-4 -mx-1 px-1 snap-x snap-mandatory no-scrollbar">
// 				{items.map((item, idx) => (
// 					<div
// 						key={idx}
// 						className="min-w-[260px] bg-white rounded-2xl p-3 border border-gray-100 shadow-sm hover:shadow-md transition-shadow snap-center flex flex-col"
// 					>
// 						<div className="aspect-[4/3] w-full bg-gray-50 rounded-xl overflow-hidden mb-3 relative group">
// 							<img
// 								src={item.image}
// 								alt={item.name}
// 								className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
// 							/>
// 							<div className="absolute top-2 left-2">
//                                 <span
// 	                                className="text-[10px] font-custom-bold px-2 py-1 rounded-md bg-white/90 text-gray-800 backdrop-blur-sm shadow-sm">
//                                     {item.tag}
//                                 </span>
// 							</div>
// 						</div>
// 						<h4 className="font-custom-bold text-gray-900 text-sm leading-tight mb-1 line-clamp-1">{item.name}</h4>
// 						<div className="mt-auto flex items-center justify-between">
// 							<p className="text-base font-custom-bold text-orange-600">{item.price}</p>
// 						</div>
// 					</div>
// 				))}
// 			</div>
// 		</div>
// 	);
// };
//
// // --- COMPONENT: Services Grid (The "Backup" Hero) ---
// // Used when there are no products. Displays services as big cards.
// const ServiceHeroGrid = ({services}) => {
// 	return (
// 		<div className="w-full mb-6">
// 			<div className="flex items-center justify-between mb-4">
// 				<h3 className="text-lg font-custom-bold text-gray-900 flex items-center gap-2">
// 					<Wrench className="w-5 h-5 text-blue-500"/>
// 					Our Key Services
// 				</h3>
// 			</div>
// 			<div className="grid grid-cols-2 gap-3">
// 				{services.slice(0, 4).map((service, idx) => (
// 					<div key={idx}
// 					     className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm flex flex-col items-start gap-3 hover:border-blue-200 transition-colors">
// 						<div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
// 							<Star className="w-5 h-5 fill-current"/>
// 						</div>
// 						<div>
// 							<h5 className="font-custom-bold text-gray-800 text-sm leading-tight">{service}</h5>
// 							<p className="text-xs text-gray-500 mt-1">Professional Service</p>
// 						</div>
// 					</div>
// 				))}
// 			</div>
// 		</div>
// 	);
// };
//
// export const YellowPageEntityPublicProfile = () => {
// 	const [isEndorsed, setIsEndorsed] = useState(false);
// 	const [endorsementCount, setEndorsementCount] = useState(142);
//
// 	// Sample Data
// 	const entityData = {
// 		name: 'TechFix Solutions',
// 		ownerName: 'Rajesh Kumar',
// 		category: 'Electronics & Electrical',
// 		area: 'Bhayandar West',
// 		pinCode: '401101',
// 		address: 'Shop No. 15, Maxus Mall, Near Railway Station',
// 		mobile: '+91 98765 43210',
// 		whatsapp: '+91 98765 43210',
// 		email: 'info@techfixsolutions.com',
// 		description: 'We sell latest mobile phones, laptops, and electronic gadgets. We also provide professional repair services for all brands of smartphones, laptops, and electronic devices with genuine spare parts and warranty.',
// 		images: ['/assets/tech-filler-1.png'],
//
// 		// TOGGLE THIS ARRAY TO TEST EMPTY STATE:
// 		featuredItems: [
// 			{name: "iPhone Screen Replacement", price: "₹1,500", image: "/assets/tech-filler-1.png", tag: "Service"},
// 			{name: "Samsung Galaxy S23 Ultra", price: "₹1,24,999", image: "/assets/tech-filler-2.png", tag: "Product"},
// 			{name: "Laptop SSD Upgrade", price: "₹2,500", image: "/assets/tech-filler-3.png", tag: "Service"}
// 		],
// 		// featuredItems: [], // <--- Try uncommenting this to see the "Service Hero" view
//
// 		services: ['Mobile Repair', 'Laptop Sales', 'Screen Replacement', 'Data Recovery', 'Software Install'],
// 		specialOffers: ['Free screen guard with phone purchase', '10% student discount'],
// 		views: 1205,
// 		isVerified: true,
// 		operatingHours: {
// 			monday: '9:00 AM - 8:00 PM',
// 			tuesday: '9:00 AM - 8:00 PM',
// 			wednesday: '9:00 AM - 8:00 PM',
// 			thursday: '9:00 AM - 8:00 PM',
// 			friday: '9:00 AM - 8:00 PM',
// 			saturday: '9:00 AM - 8:00 PM',
// 			sunday: '10:00 AM - 6:00 PM'
// 		}
// 	};
//
// 	// Logic: Do we show Products or Services in the center?
// 	const hasProducts = entityData.featuredItems && entityData.featuredItems.length > 0;
//
// 	const getCurrentDay = () => {
// 		const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
// 		return days[new Date().getDay()];
// 	};
//
// 	const isOpenNow = () => {
// 		if (!entityData.operatingHours) return false;
// 		const currentHours = entityData.operatingHours[getCurrentDay()];
// 		return currentHours && currentHours !== 'Closed';
// 	};
//
// 	// --- Layout Components ---
// 	const BentoCard = ({children, className = ""}) => (
// 		<div
// 			className={`bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col ${className}`}>
// 			{children}
// 		</div>
// 	);
//
// 	return (
// 		<div className="min-h-screen w-full bg-[#F7F7F7] relative flex flex-col items-center">
// 			<Header/>
//
// 			<main className={`
//                 w-full 2xl:max-w-[1600px] mx-auto bg-[#F7F7F7]
//                 flex flex-col gap-4 min-h-screen px-3 pb-4
//                 portrait:pt-[4.75rem] portrait:sm:pt-[6.25rem] landscape:pt-[3.5rem]
//                 lg:h-screen lg:overflow-hidden lg:pt-[4.5rem] lg:pb-6 lg:px-6
//                 lg:grid lg:grid-cols-12 lg:gap-6
//             `}>
//
// 				{/* --- COLUMN 1: LEFT (Contact & Identity) --- */}
// 				<div className="lg:col-span-3 lg:h-full lg:overflow-hidden">
// 					<BentoCard className="h-fit lg:h-full">
// 						<div
// 							className="p-6 flex flex-col items-center text-center bg-gradient-to-b from-orange-50/50 to-white">
// 							<div className="relative mb-4">
// 								<div className="w-32 h-32 p-1 bg-white rounded-full shadow-md">
// 									<img src={entityData.images[0]} alt="Profile"
// 									     className="w-full h-full object-cover rounded-full"/>
// 								</div>
// 								{entityData.isVerified && <CheckCircle
// 									className="absolute bottom-1 right-1 w-6 h-6 text-blue-500 fill-white"/>}
// 							</div>
// 							<h1 className="text-2xl font-custom-bold text-gray-900 leading-tight mb-1">{entityData.name}</h1>
// 							<p className="text-sm text-gray-500 font-custom-medium mb-4">({entityData.ownerName})</p>
// 							<span
// 								className="px-3 py-1 bg-blue-50 text-blue-700 text-xs font-custom-bold rounded-full border border-blue-100 mb-6">
//                                 {entityData.category}
//                             </span>
// 							<div className="grid grid-cols-2 gap-3 w-full">
// 								<a href={`tel:${entityData.mobile}`}
// 								   className="flex items-center justify-center gap-2 p-3 bg-green-500 hover:bg-green-600 text-white rounded-xl shadow-sm transition-colors">
// 									<Phone className="w-4 h-4"/><span className="font-custom-bold text-sm">Call</span>
// 								</a>
// 								<a href={`https://wa.me/${entityData.whatsapp}`}
// 								   className="flex items-center justify-center gap-2 p-3 bg-white border border-green-500 text-green-600 hover:bg-green-50 rounded-xl transition-colors">
// 									<MessageCircle className="w-4 h-4"/><span
// 									className="font-custom-bold text-sm">WhatsApp</span>
// 								</a>
// 							</div>
// 						</div>
//
// 						{/* Contact Details & Operating Hours (Merged) */}
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-6 border-t border-gray-100 bg-white">
// 							<h4 className="text-xs font-custom-bold text-gray-400 uppercase tracking-wider mb-4">Contact
// 								Info</h4>
// 							<div className="space-y-5">
// 								<div className="flex gap-3 items-start"><MapPin className="w-5 h-5 text-gray-400"/>
// 									<div><p className="text-sm font-bold text-gray-800">Address</p><p
// 										className="text-sm text-gray-500">{entityData.address}</p></div>
// 								</div>
// 								<div className="flex gap-3 items-center"><Mail className="w-5 h-5 text-gray-400"/>
// 									<div className="overflow-hidden"><p
// 										className="text-sm font-bold text-gray-800">Email</p><p
// 										className="text-sm text-gray-500 truncate">{entityData.email}</p></div>
// 								</div>
// 							</div>
//
// 							{/* COMPACT HOURS inside Contact Card */}
// 							<OperatingHoursCompact operatingHours={entityData.operatingHours} isOpenNow={isOpenNow}
// 							                       getCurrentDay={getCurrentDay}/>
// 						</div>
// 					</BentoCard>
// 				</div>
//
// 				{/* --- COLUMN 2: CENTER (Main Content) --- */}
// 				<div className="lg:col-span-5 lg:h-full lg:overflow-hidden flex flex-col gap-6">
//
// 					{/* TOP SECTION: Dynamic (Products OR Services) */}
// 					<div className="shrink-0">
// 						{hasProducts ? (
// 							<FeaturedHighlights items={entityData.featuredItems}/>
// 						) : (
// 							<ServiceHeroGrid services={entityData.services}/>
// 						)}
// 					</div>
//
// 					{/* BOTTOM SECTION: About Story */}
// 					<BentoCard className="flex-1 h-fit lg:h-auto">
// 						<div className="px-5 py-4 border-b border-gray-100 bg-white sticky top-0 z-10">
// 							<h3 className="font-custom-bold text-gray-800 text-lg flex items-center gap-2">
// 								<Store className="w-5 h-5 text-orange-500"/> About Us
// 							</h3>
// 						</div>
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-5 space-y-6">
// 							<div className="prose prose-sm max-w-none text-gray-600 font-custom-medium">
// 								{entityData.description}
// 							</div>
// 						</div>
// 					</BentoCard>
// 				</div>
//
// 				{/* --- COLUMN 3: RIGHT (Stats & Secondary Info) --- */}
// 				<div className="lg:col-span-4 lg:h-full lg:overflow-hidden flex flex-col gap-4 lg:gap-6">
//
// 					{/* Stats Card */}
// 					<BentoCard className="h-fit lg:h-auto shrink-0 p-4">
// 						<div className="grid grid-cols-2 gap-3">
// 							<button onClick={() => {
// 								setIsEndorsed(!isEndorsed);
// 								setEndorsementCount(p => isEndorsed ? p - 1 : p + 1)
// 							}}
// 							        className={`rounded-xl p-3 text-center border transition-all ${isEndorsed ? 'bg-red-50 border-red-200 text-red-600' : 'bg-gray-50 border-gray-100 hover:bg-red-50 text-gray-800'}`}>
// 								<Heart
// 									className={`w-5 h-5 mx-auto mb-1 ${isEndorsed ? 'fill-red-500' : 'text-gray-400'}`}/>
// 								<p className="text-lg font-custom-bold leading-none">{endorsementCount}</p>
// 								<p className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">Endorsements</p>
// 							</button>
// 							<div
// 								className="bg-blue-50 rounded-xl p-3 text-center border border-blue-100 cursor-default">
// 								<Eye className="w-5 h-5 text-blue-500 mx-auto mb-1"/>
// 								<p className="text-lg font-custom-bold text-gray-800 leading-none">{entityData.views}</p>
// 								<p className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">Views</p>
// 							</div>
// 						</div>
// 					</BentoCard>
//
// 					{/* Secondary Info: Offers & Tags (If products exist, tags go here. If no products, tags are in center, so we hide them here to avoid duplication) */}
// 					<BentoCard className="flex-1 h-fit lg:h-auto">
// 						<div className="px-5 py-4 border-b border-gray-100 bg-white sticky top-0 z-10">
// 							<h3 className="font-custom-bold text-gray-800 text-lg flex items-center gap-2">
// 								<Award className="w-5 h-5 text-orange-500"/> Offers & More
// 							</h3>
// 						</div>
// 						<div className="flex-1 overflow-y-auto thin-scrollbar p-5 space-y-6">
//
// 							{/* Offers */}
// 							{entityData.specialOffers.length > 0 ? (
// 								<div className="bg-green-50 border border-green-100 rounded-xl p-4">
// 									<h4 className="text-xs font-custom-bold text-green-700 uppercase tracking-wider mb-3 flex items-center gap-2">
// 										<BadgePercent className="w-4 h-4"/> Current Offers
// 									</h4>
// 									<div className="space-y-2.5">
// 										{entityData.specialOffers.map((offer, idx) => (
// 											<div key={idx} className="flex items-start gap-2 text-sm text-gray-700">
// 												<div
// 													className="w-1.5 h-1.5 bg-green-500 rounded-full mt-1.5 flex-shrink-0"/>
// 												<span className="font-custom-medium leading-tight">{offer}</span>
// 											</div>
// 										))}
// 									</div>
// 								</div>
// 							) : (
// 								<div className="text-center py-8 text-gray-400 text-sm italic">No active offers</div>
// 							)}
//
// 							{/* If we have products, show Service Tags here in sidebar. If NO products, Services are already the HERO in center, so don't repeat them. */}
// 							{hasProducts && (
// 								<div>
// 									<h4 className="text-xs font-custom-bold text-gray-400 uppercase tracking-wider mb-3">Service
// 										Tags</h4>
// 									<div className="flex flex-wrap gap-2">
// 										{entityData.services.map((service, idx) => (
// 											<span key={idx}
// 											      className="px-3 py-1.5 bg-white text-gray-600 text-xs font-custom-bold rounded-lg border border-gray-200">
//                                                 {service}
//                                             </span>
// 										))}
// 									</div>
// 								</div>
// 							)}
// 						</div>
// 					</BentoCard>
// 				</div>
// 			</main>
// 		</div>
// 	);
// };

import React from 'react';
import {
	Award,
	CheckCircle,
	ChevronRight,
	Clock,
	ExternalLink,
	Globe,
	Languages,
	MapPin,
	MessageCircle,
	Phone,
	Star,
	Store,
	User
} from 'lucide-react';
import {Header} from "../components/Header";

// --- REUSABLE COMPONENTS ---

const BentoCard = ({children, className = "", variant = "default"}) => {
	const baseClasses = "rounded-3xl shadow-sm border overflow-hidden flex flex-col transition-all duration-300 hover:shadow-md";
	const variantClasses = variant === "warm"
		? "bg-orange-50/50 border-orange-100"
		: "bg-white border-gray-200";

	return (
		<div className={`${baseClasses} ${variantClasses} ${className}`}>
			{children}
		</div>
	);
};

const TagPill = ({text, color = "blue"}) => {
	const colors = {
		blue: "bg-blue-50 text-blue-700 border-blue-100",
		orange: "bg-orange-50 text-orange-700 border-orange-100",
		green: "bg-green-50 text-green-700 border-green-100",
		gray: "bg-gray-100 text-gray-700 border-gray-200"
	};
	return (
		<span className={`px-3 py-1 text-xs font-bold rounded-full border ${colors[color] || colors.gray}`}>
            {text}
        </span>
	);
};

export const YellowPageEntityPublicProfile = () => {
	// Mock Data
	const entityData = {
		name: 'Shree Ganesh Caterers & Events',
		tagline: 'Serving authentic Puneri taste since 1998.',
		ownerName: 'Mr. Rajesh Deshpande',
		nativePlace: 'Chiplun, Ratnagiri',
		languages: ['Marathi', 'Hindi', 'English'],
		category: 'Catering & Events',
		rating: 4.8,
		reviewCount: 125,
		isVerified: true,
		mobile: '+91 98765 43210',
		whatsapp: '+91 98765 43210',
		website: 'www.shreeganesh.com',
		address: 'Shop No. 15, Maxus Mall, Near Railway Station, Bhayandar West, 401101',
		description: 'We are a family-run business dedicated to bringing the authentic taste of Konkan and Pune to your special occasions. Specializing in traditional Maharashtrian pangat, we ensure every guest leaves with a satisfied soul.',
		services: [
			'Wedding Catering (Pangat style)',
			'Corporate Lunch Boxes',
			'Festival Special (Modak/Puran Poli)',
			'Birthday Party Orders',
			'Small Get-together Catering'
		],
		images: [
			'/assets/tech-filler-1.png', // Hero Image
			'/assets/tech-filler-2.png', // Side Top
			'/assets/tech-filler-3.png', // Side Bottom
			'/assets/tech-filler-1.png',
			'/assets/tech-filler-2.png'
		],
		operatingHours: {
			monday: '10:00 AM - 9:00 PM',
			tuesday: '10:00 AM - 9:00 PM',
			wednesday: '10:00 AM - 9:00 PM',
			thursday: '10:00 AM - 9:00 PM',
			friday: '10:00 AM - 9:00 PM',
			saturday: '10:00 AM - 9:00 PM',
			sunday: 'Closed'
		}
	};

	const getCurrentDay = () => {
		const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
		return days[new Date().getDay()];
	};

	const isOpenNow = () => {
		const currentHours = entityData.operatingHours[getCurrentDay()];
		return currentHours && currentHours !== 'Closed';
	};

	return (
		<div className="min-h-screen w-full bg-[#F7F7F7] relative flex flex-col items-center font-sans">
			<Header/>

			<main className={`
                w-full 2xl:max-w-[1600px] mx-auto bg-[#F7F7F7]
                flex flex-col gap-6 px-4 pb-12
                
                /* Responsive Header Spacing - Adjusted to prevent cutoff */
                pt-24 md:pt-28
                
                /* Desktop Grid Layout */
                lg:px-8 
                lg:grid lg:grid-cols-3 lg:gap-6
                
                /* Note: Removed 'h-screen' and 'overflow-hidden' to allow natural scrolling */
            `}>

				{/* =================================================================================
                    ROW 1: Header Anchor & Quick Actions
                   ================================================================================= */}

				{/* [ Module 1: The Identity Anchor ] */}
				<BentoCard className="lg:col-span-2 flex-col md:flex-row p-6 items-start md:items-center gap-6 h-auto">
					{/* Left: Profile Image */}
					<div className="relative shrink-0 mx-auto md:mx-0">
						<div
							className="w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-gray-100 overflow-hidden shadow-md ring-4 ring-white">
							<img src={entityData.images[0]} alt="Profile" className="w-full h-full object-cover"/>
						</div>
						{entityData.isVerified && (
							<div
								className="absolute -bottom-2 -right-2 bg-blue-500 p-1.5 rounded-full shadow-sm ring-2 ring-white">
								<CheckCircle className="w-4 h-4 text-white fill-none stroke-[3px]"/>
							</div>
						)}
					</div>

					{/* Right: Info */}
					<div className="flex-1 min-w-0 flex flex-col justify-center w-full text-center md:text-left">
						<div className="flex flex-wrap items-center justify-center md:justify-start gap-2 mb-3">
							<TagPill text={entityData.category} color="blue"/>
							<div
								className="flex items-center gap-1 px-2 py-1 bg-yellow-50 text-yellow-700 border border-yellow-200 rounded-full text-xs font-bold">
								<Star className="w-3 h-3 fill-yellow-500 text-yellow-500"/>
								<span>{entityData.rating}</span>
								<span
									className="text-yellow-600/70 font-medium ml-0.5">({entityData.reviewCount})</span>
							</div>
						</div>

						<h1 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight mb-2 truncate">
							{entityData.name}
						</h1>
						<p className="text-sm md:text-base text-gray-500 font-medium italic">
							"{entityData.tagline}"
						</p>
					</div>
				</BentoCard>

				{/* [ Module 2: The Action Station ] */}
				<BentoCard className="lg:col-span-1 p-5 justify-center h-full bg-white min-h-[160px]">
					<div className="flex flex-col gap-3 h-full justify-center">
						<a href={`tel:${entityData.mobile}`}
						   className="flex items-center justify-center gap-3 w-full py-4 bg-orange-600 hover:bg-orange-700 text-white rounded-xl shadow-lg shadow-orange-100 transition-all active:scale-95 group">
							<Phone className="w-5 h-5 fill-current"/>
							<span className="font-bold text-lg">Call Now</span>
						</a>
						<div className="flex gap-3">
							<a href={`https://wa.me/${entityData.whatsapp}`} target="_blank" rel="noreferrer"
							   className="flex-1 flex items-center justify-center gap-2 py-3 bg-green-600 hover:bg-green-700 text-white rounded-xl shadow-lg shadow-green-100 transition-all active:scale-95">
								<MessageCircle className="w-5 h-5"/>
								<span className="font-bold">WhatsApp</span>
							</a>
							<a href={`https://${entityData.website}`} target="_blank" rel="noreferrer"
							   className="flex-1 flex items-center justify-center gap-2 py-3 bg-white border-2 border-gray-100 text-gray-700 hover:border-gray-300 hover:bg-gray-50 rounded-xl transition-all font-bold">
								<Globe className="w-4 h-4"/>
								<span>Website</span>
							</a>
						</div>
					</div>
				</BentoCard>


				{/* =================================================================================
                    ROW 2: The "Community Trust" & "Gallery"
                   ================================================================================= */}

				{/* [ Module 3: The Community Connect - REDESIGNED ] */}
				<BentoCard className="lg:col-span-1 relative overflow-hidden flex flex-col lg:h-[28rem] min-h-[24rem]"
				           variant="warm">
					{/* Decorative Background Icon */}
					<div className="absolute -right-8 -top-8 opacity-[0.03] pointer-events-none rotate-12">
						<User className="w-48 h-48 text-orange-900"/>
					</div>

					{/* Header Section */}
					<div className="p-6 border-b border-orange-100 bg-white/40 backdrop-blur-sm relative z-10">
						<div className="flex items-center gap-3">
							<div className="p-2.5 bg-white rounded-xl shadow-sm border border-orange-100">
								<Store className="w-5 h-5 text-orange-600"/>
							</div>
							<div>
								<h3 className="text-lg font-bold text-gray-900 leading-none mb-1">Community Roots</h3>
								<p className="text-xs text-orange-700 font-medium">Verified Community Business</p>
							</div>
						</div>
					</div>

					{/* Content Section */}
					<div className="flex-1 p-6 flex flex-col justify-center gap-6 relative z-10">
						{/* Owner */}
						<div className="group">
							<div className="flex items-center gap-2 mb-1.5">
								<User className="w-4 h-4 text-orange-400"/>
								<p className="text-xs text-gray-500 font-bold uppercase tracking-wider">Owner</p>
							</div>
							<p className="text-gray-900 font-bold text-xl pl-4 border-l-2 border-orange-200 group-hover:border-orange-500 transition-colors">
								{entityData.ownerName}
							</p>
						</div>

						{/* Native Place */}
						<div className="group">
							<div className="flex items-center gap-2 mb-1.5">
								<MapPin className="w-4 h-4 text-orange-400"/>
								<p className="text-xs text-gray-500 font-bold uppercase tracking-wider">Native Place
									(Mul Gav)</p>
							</div>
							<p className="text-gray-900 font-bold text-xl pl-4 border-l-2 border-orange-200 group-hover:border-orange-500 transition-colors">
								{entityData.nativePlace}
							</p>
						</div>

						{/* Languages */}
						<div className="group">
							<div className="flex items-center gap-2 mb-2">
								<Languages className="w-4 h-4 text-orange-400"/>
								<p className="text-xs text-gray-500 font-bold uppercase tracking-wider">Languages</p>
							</div>
							<div className="pl-4">
								<div className="flex flex-wrap gap-2">
									{entityData.languages.map((lang, i) => (
										<span key={i}
										      className="text-sm bg-white px-3 py-1 rounded-lg border border-orange-100 text-gray-700 font-medium shadow-sm">
                                            {lang}
                                        </span>
									))}
								</div>
							</div>
						</div>
					</div>
				</BentoCard>

				{/* [ Module 4: The Visual Showcase - REDESIGNED GRID ] */}
				<BentoCard
					className="lg:col-span-2 relative group cursor-pointer lg:h-[28rem] min-h-[24rem] overflow-hidden bg-gray-900 border-none">
					<div className="grid grid-cols-1 md:grid-cols-3 h-full">
						{/* Hero Image (Takes 2/3rds) */}
						<div
							className="md:col-span-2 relative h-64 md:h-full border-b md:border-b-0 md:border-r border-white/10">
							<img
								src={entityData.images[0]}
								alt="Hero"
								className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
							/>
							<div
								className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"/>
							<div className="absolute bottom-6 left-6 right-6 text-white">
                                <span
	                                className="bg-orange-500/90 backdrop-blur-sm text-white text-xs font-bold px-2 py-1 rounded mb-3 inline-block shadow-sm">
                                    Featured
                                </span>
								<h3 className="font-bold text-2xl leading-tight mb-2">Our Signature Wedding Setup</h3>
								<div className="flex items-center gap-1 text-white/80 text-sm font-medium">
									<span>View highlights</span>
									<ChevronRight className="w-4 h-4"/>
								</div>
							</div>
						</div>

						{/* Side Images (Stack of 2) */}
						<div className="md:col-span-1 grid grid-cols-2 md:grid-cols-1 md:grid-rows-2 h-full">
							{/* Image 2 */}
							<div
								className="relative h-full border-r md:border-r-0 md:border-b border-white/10 overflow-hidden">
								<img
									src={entityData.images[1]}
									alt="Gallery 2"
									className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
								/>
							</div>

							{/* Image 3 with Overlay */}
							<div className="relative h-full overflow-hidden">
								<img
									src={entityData.images[2]}
									alt="Gallery 3"
									className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
								/>
								<div
									className="absolute inset-0 bg-black/50 hover:bg-black/60 transition-colors flex flex-col items-center justify-center cursor-pointer group/view">
									<span
										className="text-white font-bold text-2xl mb-1 group-hover/view:scale-110 transition-transform">20+</span>
									<span
										className="text-white/90 text-[10px] font-bold uppercase tracking-widest border-b border-white/50 pb-0.5">View Gallery</span>
								</div>
							</div>
						</div>
					</div>
				</BentoCard>


				{/* =================================================================================
                    ROW 3: Details and Context
                   ================================================================================= */}

				{/* [ Module 5: About & Specializations ] */}
				<BentoCard className="lg:col-span-2 p-6 md:p-8 flex-1 min-h-[22rem]">
					<div className="h-full flex flex-col gap-6">
						{/* About Section */}
						<div>
							<h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
								<Store className="w-5 h-5 text-gray-400"/>
								About Us
							</h3>
							<p className="text-gray-600 leading-relaxed font-medium text-base">
								{entityData.description}
							</p>
						</div>

						<div className="border-t border-gray-100"/>

						{/* Key Services */}
						<div className="flex-1">
							<h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
								<Award className="w-5 h-5 text-gray-400"/>
								Key Services
							</h3>
							<div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
								{entityData.services.map((service, idx) => (
									<div key={idx}
									     className="flex items-center gap-3 p-3.5 bg-gray-50 rounded-xl border border-gray-100 hover:border-blue-200 transition-colors group">
										<div
											className="p-1.5 bg-white border border-gray-200 rounded-full shrink-0 group-hover:border-green-300 group-hover:bg-green-50 transition-colors">
											<CheckCircle className="w-4 h-4 text-green-600"/>
										</div>
										<span className="text-gray-700 font-medium text-sm">{service}</span>
									</div>
								))}
							</div>
						</div>
					</div>
				</BentoCard>

				{/* [ Module 6: Location & Hours ] */}
				<BentoCard className="lg:col-span-1 min-h-[22rem] flex flex-col">
					{/* Top Half: Map */}
					<div
						className="h-48 lg:h-[45%] bg-blue-50 relative group overflow-hidden border-b border-gray-200 shrink-0">
						{/* Pattern background to simulate map texture */}
						<div className="absolute inset-0 opacity-40 mix-blend-multiply"
						     style={{
							     backgroundImage: 'radial-gradient(#94a3b8 1px, transparent 1px)',
							     backgroundSize: '16px 16px'
						     }}>
						</div>
						<div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
							<MapPin className="w-8 h-8 text-red-500 drop-shadow-md animate-bounce"/>
							<div className="w-2 h-1 bg-black/20 rounded-full blur-[2px]"/>
						</div>

						{/* Hover Overlay */}
						<div
							className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity"/>

						{/* Button Overlay */}
						<div className="absolute inset-x-0 bottom-4 flex justify-center">
							<button
								className="bg-white text-gray-800 text-xs font-bold px-4 py-2 rounded-full shadow-lg border border-gray-100 hover:scale-105 transition-transform flex items-center gap-1.5">
								<ExternalLink className="w-3 h-3"/> Get Directions
							</button>
						</div>
					</div>

					{/* Bottom Half: Info */}
					<div className="flex-1 p-6 bg-white flex flex-col">
						<div className="mb-6">
							<p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Address</p>
							<p className="text-sm font-medium text-gray-800 leading-snug">
								{entityData.address}
							</p>
						</div>

						<div className="mt-auto pt-5 border-t border-gray-100">
							<div className="flex justify-between items-center mb-4">
								<div className="flex items-center gap-2">
									<Clock className="w-4 h-4 text-gray-400"/>
									<span className="text-xs font-bold text-gray-500 uppercase">Hours</span>
								</div>
								<span className={`px-2.5 py-1 text-[10px] uppercase font-bold rounded-full border ${
									isOpenNow()
										? 'bg-green-50 text-green-700 border-green-100'
										: 'bg-red-50 text-red-700 border-red-100'
								}`}>
                                    {isOpenNow() ? 'Open Now' : 'Closed'}
                                </span>
							</div>
							<div className="space-y-2">
								{Object.entries(entityData.operatingHours).slice(0, 3).map(([day, time]) => (
									<div key={day}
									     className="flex justify-between text-xs text-gray-600 border-b border-gray-50 last:border-0 pb-1.5 last:pb-0">
										<span className="capitalize font-medium text-gray-500">{day}</span>
										<span className="font-bold">{time}</span>
									</div>
								))}
								<div className="text-center pt-2">
									<button
										className="text-[10px] text-blue-600 font-bold hover:underline flex items-center justify-center gap-1 w-full">
										View Full Week <ChevronRight className="w-3 h-3"/>
									</button>
								</div>
							</div>
						</div>
					</div>
				</BentoCard>

			</main>
		</div>
	);
};